import React, {
    useState,
    createContext,
    useContext,
    useEffect,
    useRef,
    useCallback
} from "react";

//import Trumbowyg from "react-trumbowyg";
//import "react-trumbowyg/dist/trumbowyg.min.css";
import DatePicker from "react-datepicker";
import { TwitterPicker } from "react-color";
import EntityAssociation from "./EntityAssociation.js";
import LoadingSpinnerImage from "./LoadingSpinnerImage.js";
import Attachments from "../Shared/Attachments.js";
import "./App.css";
import "react-datepicker/dist/react-datepicker.css";
import { datePopperConfig } from "../Shared/datePopperConfig.js";



const TaskManagerAppContext = createContext();
let debounceTimer = null;
let windowHeight = document.body.scrollHeight;
if (windowHeight == 0) {

    // Does it have a window.parent? (possibly an iframe)
    if (window.parent != null && window.parent != undefined) {
        //console.log("Going to use height from iframe: " + window.parent.scrollHeight);
        windowHeight = window.parent.scrollHeight;
    }
    else {
        //console.log("Going to use default height: 700");
        windowHeight = 700; // default fixed height if cant calculate height automatically
    }
}


const TaskManagerApp = ({ emitter, paramEntityType = null, paramEntityId = null, paramIsSlimVersion = false, paramExternalLinkedObjects = null, paramCurrentCompanyId = null, paramCurrentUserId = null, paramHasLimitedWidth = false}) => {

    const [useDummy, setUseDummy] = useState(false);
    const [currentCompanyId, setCurrentCompany] = useState(window.currentCompanyId ? window.currentCompanyId : paramCurrentCompanyId);
    const [currentUserId, setCurrentUserId] = useState(window.currentUserId ? window.currentUserId : paramCurrentUserId);
    const [isSlimVersion, setIsSlimVersion] = useState(window.isSlimVersion ? window.isSlimVersion : paramIsSlimVersion);
    const [showLeftMenu, setShowLeftMenu] = useState(window.showLeftMenu !== undefined ? window.showLeftMenu : true);
    const [isPaneOpen, setIsPaneOpen] = useState(false);
    const [taskView, setTaskView] = useState("table");
    const [currentTask, setCurrentTask] = useState(null);
    const [currentEntityType, setCurrentEntityType] = useState(window.currentEntityType ? window.currentEntityType : paramEntityType);
    const [currentEntityId, setCurrentEntityId] = useState(window.currentEntityId ? window.currentEntityId : paramEntityId);
    const [loadTaskByDefault, setLoadTaskByDefault] = useState(window.loadTaskByDefault ? window.loadTaskByDefault : null);
    const [currentTaskListPage, setCurrentTaskListPage] = useState(1);
    const [addTaskRecurrency, setAddTaskRecurrency] = useState(0);
    const [addTaskRecurrencyEndDate, setAddTaskRecurrencyEndDate] = useState();
    const [errorAddTaskRecurrencyEndDate, setErrorAddTaskRecurrencyEndDate] = useState("");
    const [hasMoreData, setHasMoreData] = useState(true);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [windowSpacing, setWindowSpacing] = useState((window.isSlimVersion ? "50px" : "400px"));
    const [menu, setMenu] = useState([]);
    const [fullMenuObject, setFullMenuObject] = useState(null);
    const [firstMenuLoad, setFirstMenuLoad] = useState(true);
    const [breadcrumbs, setBreadcrumbs] = useState([]);
    const [isLoadingMenu, setIsLoadingMenu] = useState([]);
    const [whereAmI, setWhereAmI] = useState("All Tasks");
    const [tasks, setTasks] = useState([]);
    const [loadedSubTasksForTaskId, setLoadedSubTasksForTaskId] = useState([]);
    const [currentTasksPage, setCurrentTasksPage] = useState(1);
    const [isAddingTask, setIsAddingTask] = useState(false);
    const [isLoadingTasks, setIsLoadingTasks] = useState(false);
    const [isLoadingSubTasks, setIsLoadingSubTasks] = useState(null);
    const [isLoadingPaneSubTasks, setIsLoadingPaneSubTasks] = useState(false);
    const [alreadyLoadedSubTasks, setAlreadyLoadedSubTasks] = useState(false);
    const [currentSubTasksList, setCurrentSubTasksList] = useState([]);
    const [reloadSubTasks, setReloadSubTasks] = useState(false);
    const [addTaskEntityTypesList, setAddTaskEntityTypesList] = useState([]);
    const [linkedObjectsList, setLinkedObjectsList] = useState([]);
    const [defaultLinkedObjectsList, setDefaultLinkedObjectsList] = useState([]);
    const [showAllFields, setShowAllFields] = useState(false);
    const [isEditingFilterCompleteIncomplete, setIsEditingFilterCompleteIncomplete] = useState(false);
    const [filterCompleteIncomplete, setFilterCompleteIncomplete] = useState("incomplete");
    const [isSavingTask, setIsSavingTask] = useState(false);
    const [isShowingDeleteConfirmation, setIsShowingDeleteConfirmation] = useState(false);
    const [isDeletingTask, setIsDeletingTask] = useState(false);
    const [taskSearchText, setTaskSearchText] = useState("");
    const [defaultTaskListSortByField, setDefaultTaskListSortByField] = useState("DueDate");
    const [defaultTaskListSortByType, setDefaultTaskListSortByType] = useState("ASCENDING");
    const [taskListSortByField, setTaskListSortByField] = useState(defaultTaskListSortByField);
    const [taskListSortByType, setTaskListSortByType] = useState(defaultTaskListSortByType);
    const [saveMessage, setSaveMessage] = useState("");
    const [isShowingSaveMessage, setIsShowingSaveMessage] = useState(false);
    const [isTaskListVisible, setIsTaskListVisible] = useState(false);
    const [addTaskStartDate, setAddTaskStartDate] = useState(null);
    const [addTaskEndDate, setAddTaskEndDate] = useState(null);
    const [addTaskName, setAddTaskName] = useState("");
    const [addTaskAssignedTo, setAddTaskAssignedTo] = useState(window.currentUserId);
    const [addTaskDescription, setAddTaskDescription] = useState("");
    const [addTaskParentTaskId, setAddTaskParentTaskId] = useState(null);
    const [errorAddTaskName, setErrorAddTaskName] = useState(false);
    const [errorAddTaskDescription, setErrorAddTaskDescription] = useState(false);
    const [errorAddTaskStartDate, setErrorAddTaskStartDate] = useState(false);
    const [errorAddTaskEndDate, setErrorAddTaskEndDate] = useState(false);
    const [errorCurrentTaskName, setErrorCurrentTaskName] = useState(false);
    const [isLoadingTaskDetails, setIsLoadingTaskDetails] = useState(false);
    const [errorCurrentTaskDescription, setErrorCurrentTaskDescription] = useState(false);
    const [errorCurrentTaskStartDate, setErrorCurrentTaskStartDate] = useState(false);
    const [errorCurrentTaskEndDate, setErrorCurrentTaskEndDate] = useState(false);
    const [clearEntitySearchResults, setClearEntitySearchResults] = useState(0);
    const [visibleAddTaskPopup, setVisibleAddTaskPopup] = useState(false);
    const [users, setUsers] = useState([]);
    const [priorities, setPriorities] = useState([]);
    const [recurrences, setRecurrences] = useState([]);
    const [completeness, setCompleteness] = useState([]);
    const [boards, setBoards] = useState([]);
    const [isSavingBoard, setIsSavingBoard] = useState(false);
    const [showAssignedTo, setShowAssignedTo] = useState("Company"); // Me | Company
    const [completionStatus, setCompletionStatus] = useState(window.showAllTasks ? "All" : "Incomplete");
    const [possibleCompletionStatus, setPossibleCompletionStatus] = useState([]);
    const [taskHasMoreComments, setTaskHasMoreComments] = useState(true);
    const [comments, setComments] = useState([]);
    const [commentsPage, setCommentsPage] = useState(0);
    const [isLoadingTaskCountSummary, setIsLoadingTaskCountSummary] = useState(false);
    const [taskCountSummary, setTaskCountSummary] = useState({});
    const [visibleTaskDetailsTab, setVisibleTaskDetailsTab] = useState("entities");
    const [errorLoadingTaskDetails, setErrorLoadingTaskDetails] = useState(false);
    const [externalLinkedObjects, setExternalLinkedObjects] = useState(window.externalLinkedObjects ? window.externalLinkedObjects : paramExternalLinkedObjects);
    const [hasLimitedWidth, setHasLimitedWidth] = useState(paramHasLimitedWidth); //if true probably is coming from an integration in the CM indicating there is limited width available for the TM (adjusts sizes acordingly)
    const [isProcessingFollow, setIsProcessingFollow] = useState(false);
    const [notifyUser, setNotifyUser] = useState(false);
    const [changedAssignee, setChangedAssignee] = useState(false);
    const [isReviewApproved, setIsReviewApproved] = useState(window.isReviewApproved ? window.isReviewApproved : false);
    const [reachedAllowance, setReachedAllowance] = useState(window.reachedAllowance ? window.reachedAllowance : false);
    const [showRefreshLastLoadData, setShowRefreshLastLoadData] = useState(false);
    const [showBreadcrumbs, setShowBreadcrumbs] = useState(window.showBreadcrumbs != undefined ? window.showBreadcrumbs : true);
    const [showWhereAmI, setShowWhereAmI] = useState(window.showWhereAmI != undefined ? window.showWhereAmI : true);
    const [parentTaskOriginalLinkedToObjectsList, setParentTaskOriginalLinkedToObjectsList] = useState(null);

    const [isEditingField, setIsEditingField] = useState({
        name: false,
        description: false,
        assignedTo: false,
        priority: false,
        completed: false,
        estimatedTime: false,
        createdDate: false,
        startDate: false,
        dueDate: false,
        boardStep: false
    });


    


    const showHeaderlessCountSummaries = window.showHeaderlessCountSummaries != undefined ? window.showHeaderlessCountSummaries : false;

    useEffect(() => {

        // Is there any external currentEntityType/Id? (possibly from including the task manager in the assessment card or other page?)
        let localCurrentEntityType = paramEntityType;
        let localCurrentEntityId = paramEntityId;
        
        if ((localCurrentEntityType == null && window.currentEntityType != "" && window.currentEntityType != undefined) || (localCurrentEntityId == null && window.currentEntityId != "" && window.currentEntityId != undefined)) {
            localCurrentEntityType = window.currentEntityType;
            localCurrentEntityId = window.currentEntityId;

            setCurrentEntityType(localCurrentEntityType);
            setCurrentEntityId(localCurrentEntityId);

            getEntity(localCurrentEntityType, localCurrentEntityId).then((data) => setWhereAmI(data.EntityName));
        }


        loadMenu(localCurrentEntityType, localCurrentEntityId);

        loadEntities();

        loadUsers();

        setPriorities([
            { id: 1, name: "High" },
            { id: 2, name: "Medium" },
            { id: 3, name: "Low" },
            { id: 4, name: "None" },
        ]);

        setRecurrences([
            { id: 0, name: "Does not repeat" },
            { id: 1, name: "Weekly" },
            { id: 2, name: "Monthly" },
            { id: 3, name: "Yearly" },
        ]);

        setCompleteness([
            { id: 0, name: "Incomplete" },
            { id: 1, name: "Completed" },
        ]);

        setPossibleCompletionStatus([
            { value: "All", name: "All Tasks" },
            { value: "Incomplete", name: "Incomplete Tasks" },
            { value: "Completed", name: "Completed Tasks" },
        ]);

        loadBoards();

        loadExternalLinkedObjects();

        if (loadTaskByDefault)
            loadTaskDetails(loadTaskByDefault);


    }, []);




    useEffect(() => {

        emitter.on("createNewTask", handleNewTaskEvent);

        return () => {
            emitter.off("createNewTask", handleNewTaskEvent);
        };

    }, [linkedObjectsList]);


    const handleNewTaskEvent = ({ taskTitle, taskDescription, taskStartDate }) => {

        showAddTaskPopup();

        setAddTaskName(taskTitle);
        setAddTaskDescription(taskDescription);
        setAddTaskStartDate(taskStartDate);
    };





    useEffect(() => {

        emitter.on("reloadAllTasks", reloadAllTasks);

        return () => {
            emitter.off("reloadAllTasks", reloadAllTasks);
        };

    }, [tasks]);

    const reloadAllTasks = () => {

        loadTasks({ nextPage: false, localEntityType: paramEntityType, localEntityId: paramEntityId });
    };






    /*
     * This useEffect and messageHandler function handle the button click to create a new task coming from outside the React app (from the Review tab of the assessement card)
     * Not currently being used due to context problems between the event listener state and the normal app state...
     */
    /*
    useEffect(() => {

        console.log("updated defaultLinkedObjectsList");

        window.removeEventListener('message', messageHandler);
        window.addEventListener('message', messageHandler);

    }, [defaultLinkedObjectsList])

    const messageHandler = async () => {

        // Check if the message is from the parent window
        if (event.source !== window.parent) {
            return;
        }

        let data = event.data;

        if (data.action != null && data.action == "createNewTask") {

            // Responds back to parent caller
            const responseData = { action: "createNewTask", response: 'triggered' };
            window.parent.postMessage(responseData, '*');

            console.log("going to run the createNewTaskHandler");

            // Show create task popup
            showAddTaskPopup(true);

            setAddTaskName(data.taskName);
            setAddTaskDescription(data.taskDescription);
            setAddTaskStartDate(data.taskStartDate);
            setAddTaskEndDate(data.taskEndDate);
            setAddTaskAssignedTo(data.userId);

            setLinkedObjectsList([...defaultLinkedObjectsList]);
        }
    };
    */



    /*
     * Are there any external entities to auto associate? (possibly coming from the review assessement card)?
     */
    const loadExternalLinkedObjects = async () => {

        if (externalLinkedObjects != undefined) {

            let newObjects = [];

            Promise.all(
                externalLinkedObjects.map(async (item) => {

                    if (item.EntityType == "systematic-review-item") {

                        let split = item.EntityId.split(".");
                        let systematicReviewId = split[0];
                        let systematicReviewItemId = split[0] + "." + split[1]; // See if backend can change this to work with "." (same as assessment card) instead of "|"

                        // In the case of an sr item we are in the iframe so we have to get the parent sr type from the parent window object
                        let parentSREntityType = window.parent.currentEntityType;

                        let SREntity = await getEntity(parentSREntityType, systematicReviewId);

                        let SRItemEntity = await getEntity("systematic-review-item", systematicReviewItemId);

                        if (SREntity != null) newObjects.push(SREntity);
                        if (SRItemEntity != null) newObjects.push(SRItemEntity);
                    }
                    else {
                        let newEntity = await getEntity(item.EntityType, item.EntityId);

                        if (newEntity != null) newObjects.push(newEntity);
                    }

                })
            ).then(() => {
                if (newObjects.length > 0) {
                    setDefaultLinkedObjectsList([...newObjects]);

                    // Also update the actual linkedObjectsList for the create new task form
                    setLinkedObjectsList([...newObjects]);
                }

                // Mark task manager as ready for receiving events (this is important for the Assessment Card 'Create Task' button)
                window.isTaskManagerReady = true;

            }).catch((err) => {
                console.log("Error");
                console.log(err);
            });

        }
        else {
            // Mark task manager as ready for receiving events (this is important for the Assessment Card 'Create Task' button)
            window.isTaskManagerReady = true;
        }
    }







    /* Opens the side pane and loads the task details */
    const loadTaskDetails_OLDMETHOD = (taskId, e) => {
        e.stopPropagation();

        let currentTask = tasks.find((item) => item.Id === taskId);

        // Load task details
        setCurrentTask(null);
        setCurrentTask(currentTask);

        // Load related entities list
        setLinkedObjectsList(currentTask.Relationship_Task_Entity);

        // Clear errors
        setErrorCurrentTaskName(false);
        setErrorCurrentTaskStartDate(false);
        setErrorCurrentTaskEndDate(false);

        // Clear search results inside EntityAssociation component (trigger internal useEffect from outside)
        setClearEntitySearchResults(clearEntitySearchResults + 1);

        // Close add task in case it's opened
        showAddTaskPopup(false);

        // Hide delete confirmation if visible
        setIsShowingDeleteConfirmation(false);

        // Open side pane
        if (!isPaneOpen) togglePane();
    };





    /* Opens the side pane and loads the task details */
    const loadTaskDetails = (taskId, e = null) => {

        if (e)
            e.stopPropagation();

        // Clear errors
        setErrorCurrentTaskName(false);
        setErrorCurrentTaskStartDate(false);
        setErrorCurrentTaskEndDate(false);
        setErrorLoadingTaskDetails(false);

        // Clear search results inside EntityAssociation component (trigger internal useEffect from outside)
        setClearEntitySearchResults(clearEntitySearchResults + 1);

        // Close add task in case it's opened
        showAddTaskPopup(false);

        // Hide delete confirmation if visible
        setIsShowingDeleteConfirmation(false);

        // Resets comment section
        setTaskHasMoreComments(true);
        setComments([]);
        setCommentsPage(0);

        // Resets subtasks list in pane
        setCurrentSubTasksList([]);
        setIsLoadingPaneSubTasks(false);
        setAlreadyLoadedSubTasks(false);

        // Set pane tab to Entities
        setVisibleTaskDetailsTab("entities");

        // Remove saved linked to entities if a sub task was loaded/created meanwhile
        setParentTaskOriginalLinkedToObjectsList(null);


        // Open side pane
        if (!isPaneOpen) togglePane();

        setIsLoadingTaskDetails(true);

        let loadTaskURL =
            `/umbraco/api/TaskManagerApi/Task?` +
            `taskId=${encodeURIComponent(taskId)}&`;

        fetch(loadTaskURL)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401) {
                        closePane();
                        document.dispatchEvent(new Event("api:unauthorized"));
                    }

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {

                if (data.Id) {
                    let currentTask = data;

                    // Load task details
                    setCurrentTask(null);
                    setCurrentTask(currentTask);

                    // Activate notification box by default
                    setNotifyUser(true);
                    // Load related entities list
                    setLinkedObjectsList(currentTask.Relationship_Task_Entity);
                }

            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                setErrorLoadingTaskDetails(true);
            })
            .finally(() => {
                setIsLoadingTaskDetails(false);
            });


    };

    /* Toggles the side pane */
    const togglePane = () => {
        setIsPaneOpen(!isPaneOpen);
    };

    const closePane = () => {
        setIsPaneOpen(false);
    };


    const loadEntities = () => {

        // For now, the entities are retrieved by getting the menu and checking which items are "IsSearchable"
        let loadEntitiesURL = "/umbraco/api/TaskManagerApi/Menu?entityType=&entityId=";

        fetch(loadEntitiesURL)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {

                // Set the Entity types that can be used in the create/edit task
                if (addTaskEntityTypesList.length == 0) {
                    let listOfEntities = [];
                    data.Nodes.map((item) => {
                        if (item.IsSearchable) {
                            listOfEntities.push(item);
                        }
                    });

                    setAddTaskEntityTypesList(listOfEntities);
                }
            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
            })
            .finally(() => {
            });

    }




    const loadMenu = (entityType, entityId) => {
        // Requested a different entitytype/entityid?

        //console.log("loadMenu entityType", entityType);
        //console.log("loadMenu entityId", entityId);

        let localCurrentEntityType = currentEntityType;
        let localCurrentEntityId = currentEntityId;

        if (entityType != localCurrentEntityType || entityId != localCurrentEntityId) {

            setCurrentEntityId(entityId);
            setCurrentEntityType(entityType);
            setCurrentTaskListPage(1);
            setHasMoreData(true);

            localCurrentEntityType = entityType;
            localCurrentEntityId = entityId;
        }

        // Is it the first time loading the menu?
        if (firstMenuLoad) {
            setFirstMenuLoad(false);
        }
        else {
            // if it was the user changing the menu than clears the default linked objects because
            // they are already in a different place to add a task, not the initial default place
            setDefaultLinkedObjectsList([]);
        }

        // Reset ordering
        setTaskListSortByField(defaultTaskListSortByField);
        setTaskListSortByType(defaultTaskListSortByType);

        // Reset search string
        let emptyTaskSearchText = "";
        setTaskSearchText(emptyTaskSearchText);

        // Move to List view
        setTaskView("table");

        // Does the selected menu option have children? If so, go get next menu
        // Also go get it if entityType && entityId == null (gets the root menu)

        let menuOption = menu.find((item) => item.EntityType == localCurrentEntityType && item.EntityId == localCurrentEntityId);

        if (menuOption == undefined || menuOption?.HasChildren || (localCurrentEntityType == null && localCurrentEntityId == null)) {

            let argEntityType = localCurrentEntityType;
            let argEntityId = localCurrentEntityId;

            // This is a hammer-fix for now because we don't have this entityType in the menu. It should show the SRs in that case
            if (argEntityType == "systematic-review-item") argEntityType = "systematic-review";

            let loadMenuURL =
                `/umbraco/api/TaskManagerApi/Menu?` +
                `entityType=` + (argEntityType == null ? "" : argEntityType) + `&` +
                `entityId=` + (argEntityId == null ? "" : argEntityId) + `&`;

            
            setIsLoadingMenu(true);

            fetch(loadMenuURL)
                .then((response) => {
                    if (!response.ok) {
                        if (response.status === 401)
                            document.dispatchEvent(new Event("api:unauthorized"));

                        throw new Error("Network response was not ok");
                    }
                    return response.json();
                })
                .then((data) => {
                    

                    setFullMenuObject(data);

                    var menuList = [];
                    data.Nodes.map((item) => menuList.push(item));
                    setMenu(menuList);


                    // Set breadcrumbs
                    setBreadcrumbs(data.BreadCrumbs);

                })
                .catch((error) => {
                    // Handle any errors that occurred during the fetch
                })
                .finally(() => {
                    setIsLoadingMenu(false);
                });
        }

        // LOAD TASKS

        loadTasks({
            localSearch: emptyTaskSearchText,
            localSortType: defaultTaskListSortByType,
            localSortBy: defaultTaskListSortByField,
            localEntityType: localCurrentEntityType,
            localEntityId: localCurrentEntityId
        });

        // Load Task Count Summary Info
        loadTaskCountSummary(localCurrentEntityType, localCurrentEntityId);
    };

    const getDummyMenu = (entityType, entityId) => {
        let structure = {
            null: {
                Title: "Main Menu",
                EntityType: null,
                EntityId: null,
                BreadCrumbs: [
                    { Name: "Task Manager", EntityType: null, EntityId: null }
                ],
                Nodes: [
                    {
                        Name: "All Tasks",
                        EntityType: null,
                        EntityId: null,
                        IsSearchable: false,
                        IsGroupHeader: true,
                        HasChildren: false,
                        ItemCount: Math.round(Math.random() * 150)
                    },
                    {
                        Name: "Systematic Reviews",
                        EntityType: "systematicreviews",
                        EntityId: null,
                        IsSearchable: true,
                        IsGroupHeader: true,
                        HasChildren: true,
                        ItemCount: Math.round(Math.random() * 150)
                    },
                    {
                        Name: "Systematic Review Groups",
                        EntityType: "systematicreviewsgroups",
                        EntityId: null,
                        IsSearchable: true,
                        IsGroupHeader: false,
                        HasChildren: true,
                        ItemCount: Math.round(Math.random() * 150)
                    },
                    {
                        Name: "Products",
                        EntityType: "productportfolio",
                        EntityId: null,
                        IsSearchable: false,
                        IsGroupHeader: true,
                        HasChildren: false,
                        ItemCount: Math.round(Math.random() * 150)
                    },
                    {
                        Name: "Product Families",
                        EntityType: "productfamilies",
                        EntityId: null,
                        IsSearchable: true,
                        IsGroupHeader: false,
                        HasChildren: true,
                        ItemCount: Math.round(Math.random() * 150)
                    },
                    {
                        Name: "Product SKUs",
                        EntityType: "productskus",
                        EntityId: null,
                        IsSearchable: true,
                        IsGroupHeader: false,
                        HasChildren: true,
                        ItemCount: Math.round(Math.random() * 150)
                    },
                    {
                        Name: "Country Registrations",
                        EntityType: "countryregistrations",
                        EntityId: null,
                        IsSearchable: false,
                        IsGroupHeader: true,
                        HasChildren: false,
                        ItemCount: Math.round(Math.random() * 150)
                    },
                    {
                        Name: "Countries",
                        EntityType: "countries",
                        EntityId: null,
                        IsSearchable: true,
                        IsGroupHeader: false,
                        HasChildren: true,
                        ItemCount: Math.round(Math.random() * 150)
                    },
                    {
                        Name: "Certificates",
                        EntityType: "certificates",
                        EntityId: null,
                        IsSearchable: true,
                        IsGroupHeader: false,
                        HasChildren: true,
                        ItemCount: Math.round(Math.random() * 150)
                    },
                    {
                        Name: "Product Registrations",
                        EntityType: "productregistrations",
                        EntityId: null,
                        IsSearchable: true,
                        IsGroupHeader: false,
                        HasChildren: true,
                        ItemCount: Math.round(Math.random() * 150)
                    },
                    {
                        Name: "Operators",
                        EntityType: "operators",
                        EntityId: null,
                        IsSearchable: true,
                        IsGroupHeader: false,
                        HasChildren: true,
                        ItemCount: Math.round(Math.random() * 150)
                    }
                ]
            },

            systematicreviews: {
                title: "Systematic Reviews",
                EntityType: "systematicreviews",
                EntityId: null,
                BreadCrumbs: [
                    { Name: "Task Manager", EntityType: null, EntityId: null },
                    {
                        Name: "Systematic Reviews",
                        EntityType: "systematicreviews",
                        EntityId: null
                    }
                ],
                Nodes: [
                    {
                        Name: "SR 1",
                        EntityType: "systematicreview",
                        EntityId: 100,
                        IsSearchable: false,
                        IsGroupHeader: false,
                        HasChildren: false,
                        ItemCount: Math.round(Math.random() * 150)
                    },
                    {
                        Name: "SR 2",
                        EntityType: "systematicreview",
                        EntityId: 200,
                        IsSearchable: false,
                        IsGroupHeader: false,
                        HasChildren: false,
                        ItemCount: Math.round(Math.random() * 150)
                    },
                    {
                        Name: "SR 3",
                        EntityType: "systematicreview",
                        EntityId: 300,
                        IsSearchable: false,
                        IsGroupHeader: false,
                        HasChildren: false,
                        ItemCount: Math.round(Math.random() * 150)
                    }
                ]
            },

            productfamilies: {
                title: "Product Families",
                EntityType: "productfamilies",
                EntityId: null,
                BreadCrumbs: [
                    { Name: "Task Manager", EntityType: null, EntityId: null },
                    {
                        Name: "Families",
                        EntityType: "productfamilies",
                        EntityId: null
                    }
                ],
                Nodes: [
                    {
                        Name: "Product Family 1",
                        EntityType: "Product",
                        EntityId: 1,
                        IsSearchable: false,
                        IsGroupHeader: false,
                        HasChildren: false,
                        ItemCount: Math.round(Math.random() * 150)
                    },
                    {
                        Name: "Product Family 2",
                        EntityType: "Product",
                        EntityId: 2,
                        IsSearchable: false,
                        IsGroupHeader: false,
                        HasChildren: false,
                        ItemCount: Math.round(Math.random() * 150)
                    },
                    {
                        Name: "Product Family 3",
                        EntityType: "Product",
                        EntityId: 3,
                        IsSearchable: false,
                        IsGroupHeader: false,
                        HasChildren: false,
                        ItemCount: Math.round(Math.random() * 150)
                    }
                ]
            },

            countries: {
                title: "Countries",
                EntityType: "countries",
                EntityId: null,
                BreadCrumbs: [
                    { Name: "Task Manager", EntityType: null, EntityId: null },
                    {
                        Name: "Countries",
                        EntityType: "countries",
                        EntityId: null
                    }
                ],
                Nodes: [
                    {
                        Name: "Germany",
                        EntityType: "countries",
                        EntityId: 7,
                        IsSearchable: false,
                        IsGroupHeader: false,
                        HasChildren: false,
                        ItemCount: Math.round(Math.random() * 150)
                    },
                    {
                        Name: "Portugal",
                        EntityType: "countries",
                        EntityId: 8,
                        IsSearchable: false,
                        IsGroupHeader: false,
                        HasChildren: false,
                        ItemCount: Math.round(Math.random() * 150)
                    },
                    {
                        Name: "Spain",
                        EntityType: "countries",
                        EntityId: 8,
                        IsSearchable: false,
                        IsGroupHeader: false,
                        HasChildren: false,
                        ItemCount: Math.round(Math.random() * 150)
                    },
                    {
                        Name: "United Kingdom",
                        EntityType: "countries",
                        EntityId: 9,
                        IsSearchable: false,
                        IsGroupHeader: false,
                        HasChildren: false,
                        ItemCount: Math.round(Math.random() * 150)
                    }
                ]
            },

            productregistrations: {
                title: "Product Registrations",
                EntityType: "productregistrations",
                EntityId: null,
                BreadCrumbs: [
                    { Name: "Task Manager", EntityType: null, EntityId: null },
                    {
                        Name: "Product Registrations",
                        EntityType: "productregistrations",
                        EntityId: null
                    }
                ],
                Nodes: [
                    {
                        Name: "Registration 1",
                        EntityType: "productregistrations",
                        EntityId: 10,
                        IsSearchable: false,
                        IsGroupHeader: false,
                        HasChildren: false,
                        ItemCount: Math.round(Math.random() * 150)
                    },
                    {
                        Name: "Registration 2",
                        EntityType: "productregistrations",
                        EntityId: 11,
                        IsSearchable: false,
                        IsGroupHeader: false,
                        HasChildren: false,
                        ItemCount: Math.round(Math.random() * 150)
                    }
                ]
            },

            certificates: {
                title: "Certificates",
                EntityType: "certificates",
                EntityId: null,
                BreadCrumbs: [
                    { Name: "Task Manager", EntityType: null, EntityId: null },
                    {
                        Name: "Certificates",
                        EntityType: "certificates",
                        EntityId: null
                    }
                ],
                Nodes: [
                    {
                        Name: "Certificate 1",
                        EntityType: "productcertificates",
                        EntityId: 12,
                        IsSearchable: false,
                        IsGroupHeader: false,
                        HasChildren: false,
                        ItemCount: Math.round(Math.random() * 150)
                    },
                    {
                        Name: "Certificate 2",
                        EntityType: "productcertificates",
                        EntityId: 13,
                        IsSearchable: false,
                        IsGroupHeader: false,
                        HasChildren: false,
                        ItemCount: Math.round(Math.random() * 150)
                    }
                ]
            }
        };

        return structure[entityType];
    };

    const loadUsers = () => {
        let loadUsersURL = "/umbraco/api/TaskManagerApi/Users";

        

        fetch(loadUsersURL)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
                // Update state with the received data

                // Attribute random color do user circle
                data = data.map((item) => {
                    return {
                        ...item,
                        ["IsItMe"]: item.Id == currentUserId ? true : false
                    };
                });

                setUsers(data);
            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
            });
    };

    const doTextSearchTask = ({ localSearch }) => {
        let debouncingTime = 500;
        clearTimeout(debounceTimer);

        debounceTimer = setTimeout(() => {
            loadTasks({ localSearch: localSearch });
        }, debouncingTime);
    };




    const loadSubTasks = ({ parentTaskId, forceReload = false }) => {

        if (isLoadingTasks || isLoadingSubTasks) return;

        // If loaded tasks already exist delete them from list (it was a minimize) otherwise load those tasks (it was a maximize)
        if (loadedSubTasksForTaskId.find((item) => item == parentTaskId) && !forceReload) {

            // Remove from task list
            let newTaskList = tasks.filter((item) => item.ParentTaskId != parentTaskId);
            setTasks(newTaskList);

            // Remove from loaded ids list
            let loadedList = loadedSubTasksForTaskId.filter((item) => item != parentTaskId);
            setLoadedSubTasksForTaskId(loadedList);
        }
        else {
            loadTasks({ parentTaskId });
        }

    };



    const loadTasks = ({
        localEntityType = currentEntityType,
        localEntityId = currentEntityId,
        localSearch = taskSearchText,
        localSortType = taskListSortByType,
        localSortBy = taskListSortByField,
        localShowAssignedTo = showAssignedTo,
        nextPage = false,
        localCompletionStatus = completionStatus,
        parentTaskId = null,
    } = {}) => {

        if (isLoadingTasks || isLoadingSubTasks) {
            return;
        }

        let local_tasks = tasks;
        let local_tasks_page = currentTasksPage;

        // Is it a request for subtasks or for main tasks?
        // If it's for subtasks the parentTaskId is not null
        if (parentTaskId) {
            setIsLoadingSubTasks(parentTaskId);
            nextPage = true;    // If it's a request for subtasks it will always add to the list (checks for duplicates in the ajax done method)

            // Update loaded subtasks id list
            let newLoadedSubTasksList = loadedSubTasksForTaskId;
            newLoadedSubTasksList.push(parentTaskId);
            setLoadedSubTasksForTaskId(newLoadedSubTasksList);
        }
        else {
            setIsLoadingTasks(true);

            if (nextPage == false) {
                local_tasks = [];
                local_tasks_page = 1;
                setTasks(local_tasks);
                // Clean array of opened task (controls the arrows to open/close subtasks)
                setLoadedSubTasksForTaskId([]);

            } else {
                local_tasks_page++;
            }
        }

        setShowRefreshLastLoadData(false);
        setHasMoreData(true);
        

        if (localEntityType == null) localEntityType = "";
        if (localEntityId == null) localEntityId = "";

        // If it's a subtask request:
        if (parentTaskId) {
            localEntityType = "";
            localEntityId = "";
            localSearch = "";
            local_tasks_page = 1;
            localCompletionStatus = "All";
        }

        let loadTasksURL =
            `/umbraco/api/TaskManagerApi/Tasks?` +
            `entityType=${encodeURIComponent(localEntityType)}&` +
            `entityId=${encodeURIComponent(localEntityId)}&` +
            `search=${encodeURIComponent(localSearch)}&` +
            `sortBy=${encodeURIComponent(localSortBy)}&` +
            `sortType=${encodeURIComponent(localSortType)}&` +
            `assignedTo=${encodeURIComponent(localShowAssignedTo)}&` +
            `page=${encodeURIComponent(local_tasks_page)}&` +
            `completionStatus=${encodeURIComponent(localCompletionStatus)}&` + 
            `parentTaskId=${encodeURIComponent(parentTaskId)}&`;


        let requestOptions = { };

        

        fetch(loadTasksURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    //setHasMoreData(false);
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {


                // If the number of items is 0 it means there is no more data to retrieve (only for main tasks, not for requests of subtasks [which have parentTaskId])
                if (data.length == 0 && !parentTaskId) setHasMoreData(false);

                // Was it a fetch more request? Then append to tasks.
                if (nextPage) {

                    if (parentTaskId) {
                        // filter out already existing subtasks. Should never do this because it's called from loadSubTasks and it validates but... just to be sure.
                        data = data.filter((item) => {
                            if (local_tasks.find((t) => t.Id == item.Id))
                                return false;
                            return true;
                        });

                    }

                    let res = [...local_tasks, ...data];
                    setTasks(res);
                    

                } else {
                    setTasks(data);
                }

                setCurrentTasksPage(local_tasks_page);

            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                setShowRefreshLastLoadData(true);
                setHasMoreData(false);
            })
            .finally(() => {
                setIsLoadingTasks(false);
                setIsLoadingSubTasks(null);
            });
    };






    const loadBoards = () => {
        let loadBoardsURL = "/umbraco/api/TaskManagerApi/Board";

        
        fetch(loadBoardsURL)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {

                setBoards(data);
            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
            })
            .finally(() => {
                setIsSavingBoard(false); // if the request came from the save board method
            });
    };

    const loadTaskCountSummary = (entityType, entityId) => {
        setIsLoadingTaskCountSummary(true);

        let loadTaskCountSummaryURL =
            `/umbraco/api/TaskManagerApi/Summary?` +
            `entityType=${encodeURIComponent((entityType == null ? "" : entityType))}&` +
            `entityId=${encodeURIComponent((entityId == null ? "" : entityId))}&`;


        fetch(loadTaskCountSummaryURL)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
                let processed = {
                    me: {
                        total: 0,
                        late: 0,
                        today: 0,
                        next7days: 8
                    },
                    company: {
                        total: 0,
                        late: 0,
                        today: 0,
                        next7days: 0
                    }
                };

                let me = data.find((item) => item.TaskFor == "Me");
                let company = data.find((item) => item.TaskFor == "Company");
                processed.me.total = me.Total;
                processed.me.late = me.Late;
                processed.me.today = me.Today;
                processed.me.next7days = me.Next7Days;

                processed.company.total = company.Total;
                processed.company.late = company.Late;
                processed.company.today = company.Today;
                processed.company.next7days = company.Next7Days;


                setTaskCountSummary(processed);
            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
            })
            .finally(() => {
                setIsLoadingTaskCountSummary(false); // if the request came from the save board method
            });
    };

    // This method validates if the form field if filled, sets the error message to
    // true for that field and returns false meaning the field is not valid

    const validFormField = (field, errorFunc) => {
        if (field == "") {
            errorFunc(true);
            return false;
        }
        errorFunc(false);
        return true;
    };

    const addTask = () => {
        let addTaskURL = "/umbraco/api/TaskManagerApi/Task/";

        let newTask = {
            Name: addTaskName,
            Description: addTaskDescription,
            Priority: 4,
            StartDate: formatDateFromDatePicker(addTaskStartDate),
            DueDate: formatDateFromDatePicker(addTaskEndDate),
            EstimatedTime: 0,
            CreatedBy: currentUserId.toString(),
            AssignedTo: addTaskAssignedTo.toString(),
            Status: 0,
            CompanyId: currentCompanyId,
            Board: boards[0].Id,
            BoardStep: null,
            Relationship_Task_Entity: linkedObjectsList,
            Recurrency: addTaskRecurrency,
            RecurrencyEndDate: (addTaskRecurrencyEndDate ? formatDateFromDatePicker(addTaskRecurrencyEndDate) : null),
            ParentTaskId: addTaskParentTaskId,
            NotifyUser: notifyUser,
        };

        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(newTask)
        };

        // Validations

        let isValidForm = true;

        setErrorAddTaskName(false);
        setErrorAddTaskStartDate(false);
        setErrorAddTaskEndDate(false);

        if (!validFormField(addTaskName, setErrorAddTaskName)) isValidForm = false;
        if (!validFormField(addTaskStartDate, setErrorAddTaskStartDate))
            isValidForm = false;
        if (!validFormField(addTaskEndDate, setErrorAddTaskEndDate))
            isValidForm = false;

        if (addTaskRecurrency != 0) {
            if (!addTaskRecurrencyEndDate) {
                setErrorAddTaskRecurrencyEndDate(true);
                isValidForm = false;
            }
        }

        if (!isValidForm) return false;

        setIsAddingTask(true);

        fetch(addTaskURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
                // Update state with the received data
                if (data.Id) {
                    let newTaskList = [data, ...tasks];

                    // If it added a subtask then reload the task details pane subtask list and updates counter for the main list
                    if (addTaskParentTaskId) {
                        setReloadSubTasks(true);

                        newTaskList = newTaskList.map((item) => {
                            if (item.Id == addTaskParentTaskId)
                                item.SubtaskCount += 1;

                            return item;
                        });

                    }

                    setTasks(newTaskList);
                    showAddTaskPopup(false);
                    loadTaskCountSummary(currentEntityType, currentEntityId);
                }
            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
            })
            .finally(() => {
                setIsAddingTask(false);
            });
    };


    const checkHasIncompleteSubtasks = async (taskId) => {
        try {
            let checkURL = `/umbraco/api/TaskManagerApi/Tasks?entityType=&entityId=&search=&sortBy=DueDate&sortType=ASCENDING&assignedTo=Company&page=1&completionStatus=Incomplete&parentTaskId=${encodeURIComponent(taskId)}&`;
            let response = await fetch(checkURL);
            if (response.ok) {
                let data = await response.json();
                return data.length > 0;
            }
        } catch (err) {
            console.error("Error checking subtasks:", err);
        }
        return false;
    };


    const saveCurrentTask = async () => {
        // Validations

        let isValidForm = true;

        setErrorCurrentTaskName(false);
        setErrorCurrentTaskStartDate(false);
        setErrorCurrentTaskEndDate(false);

        if (!validFormField(currentTask.Name, setErrorCurrentTaskName))
            isValidForm = false;
        if (!validFormField(currentTask.StartDate, setErrorCurrentTaskStartDate))
            isValidForm = false;
        if (!validFormField(currentTask.EndDate, setErrorCurrentTaskEndDate))
            isValidForm = false;

        if (!isValidForm) return false;

        if (currentTask.CompletionStatus == 1 && currentTask.SubtaskCount > 0) {
            let hasIncomplete = await checkHasIncompleteSubtasks(currentTask.Id);
            if (hasIncomplete) {
                alert("Cannot save this task as completed. It contains incomplete subtasks.");
                return false;
            }
        }
        setIsSavingTask(true);
        setIsShowingSaveMessage(false);
        disableAllTaskFormFieldsEdit();

        // Fix the BoardStep in case of "null" value
        if (currentTask.BoardStep == "null")
            currentTask.BoardStep = null;

        // Update task remotely and if successful...

        currentTask.Relationship_Task_Entity = linkedObjectsList;
        setCurrentTask(currentTask);

        // Add user notification field
        currentTask.NotifyUser = notifyUser;


        let updateTaskURL = "/umbraco/api/TaskManagerApi/Task";

        let requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(currentTask)
        };


        fetch(updateTaskURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {

                setCurrentTask(data);

                // Update the task in the existing tasks array
                const updatedTasksArray = tasks.map((task) =>
                    task.Id === currentTask.Id ? data : task
                );
                setTasks(updatedTasksArray);
                setIsShowingSaveMessage(true);
                setChangedAssignee(false);
                loadTaskCountSummary(currentEntityType, currentEntityId);
            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
            })
            .finally(() => {
                setIsSavingTask(false);
            });
    };

    const deleteCurrentTask = async () => {
        setIsDeletingTask(true);
        disableAllTaskFormFieldsEdit();
        // Delete task remotely (backend also soft-deletes child tasks when deleting a parent)

        let deleteTaskURL =
            `/umbraco/api/TaskManagerApi/Task?` +
            `taskId=${encodeURIComponent(currentTask.Id)}&`;

        let requestOptions = {
            method: "DELETE",
            headers: { "Content-Type": "application/json" },
        };


        fetch(deleteTaskURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {

                // Delete the task (and its subtasks if it was a parent) from the local list
                let updatedTasksArray = tasks.filter(
                    (task) => task.Id !== currentTask.Id && task.ParentTaskId !== currentTask.Id
                );

                // Is it a subtask? Reduce the subtask count of the parent task then
                if (currentTask.ParentTaskId) {

                    updatedTasksArray = updatedTasksArray.map((item) => {
                        if (item.Id == currentTask.ParentTaskId)
                            item.SubtaskCount -= 1;

                        return item;
                    });

                }

                setTasks(updatedTasksArray);
                closePane();

                loadTaskCountSummary(currentEntityType, currentEntityId);
            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
            })
            .finally(() => {
                setIsDeletingTask(false);
            });
    };










    const showAddTaskPopup = (status, isSubTask = false) => {
        if (status === false) {
            setVisibleAddTaskPopup(false);

            if (parentTaskOriginalLinkedToObjectsList) {
                setLinkedObjectsList(parentTaskOriginalLinkedToObjectsList);
                setParentTaskOriginalLinkedToObjectsList(null);
            }
        } else {
            // Clean fields
            setAddTaskName(window.defaultTaskTitle != null ? window.defaultTaskTitle : "");
            setAddTaskDescription(window.defaultTaskDescription != null ? window.defaultTaskDescription : "");
            setAddTaskStartDate(window.defaultTaskStartDate != null ? window.defaultTaskStartDate : "");
            setAddTaskEndDate("");
            setAddTaskRecurrency(0);
            setAddTaskRecurrencyEndDate("");
            setNotifyUser(true);


            // Clean errors
            setErrorAddTaskName(false);
            setErrorAddTaskStartDate(false);
            setErrorAddTaskEndDate(false);
            setErrorAddTaskRecurrencyEndDate(false);

            // Set default linked objects or empty
            let newLinkedObjects = [];
            let updatedNewLinkedObjects = false;

            // Are there any default objects from external sources? (assessment card for example)
            if(Array.isArray(defaultLinkedObjectsList))
                defaultLinkedObjectsList.map((item) => {
                    newLinkedObjects.push(item);
                });

            if (isSubTask) {
                linkedObjectsList.map((item) => {
                    newLinkedObjects.push(item);
                });

            }

            // dedup
            newLinkedObjects = [
                ...new Map(
                    newLinkedObjects.map(obj => [
                        JSON.stringify([obj.EntityType, obj.EntityId]),
                        obj
                    ])
                ).values()
            ];

            if (isSubTask) {
                // to recover after saving the subtask/canceling
                setParentTaskOriginalLinkedToObjectsList(newLinkedObjects);
            }


            // Add the current entitytype/entityid where you currently are by default
            if ((currentEntityType != null && currentEntityType != "") || (currentEntityId != null && currentEntityId != "")) {

                // If it doesn't exist yet added from the external linked then add it
                if (!newLinkedObjects.find((item) => item.EntityType == currentEntityType && item.EntityId == currentEntityId)) {

                    // At this moment it didn't update anything yet of course...
                    updatedNewLinkedObjects = true;

                    if (currentEntityId) {
                        getEntity(currentEntityType, currentEntityId).then((data) => {

                            if (data) {

                                newLinkedObjects.push({
                                    EntityName: data.EntityName,
                                    EntityType: data.EntityType,
                                    EntityId: data.EntityId,
                                    EntityUrl: data.EntityUrl,
                                    Icon: ""
                                });

                            }

                            // ...the actual update only occurs here but the async code outside the if has to know before
                            setLinkedObjectsList(newLinkedObjects);

                        });
                    }
                    else {
                        newLinkedObjects.push({
                            EntityName: whereAmI,
                            EntityType: currentEntityType,
                            EntityId: currentEntityId == "" ? null : currentEntityId,
                            EntityUrl: null,
                            Icon: ""
                        });

                        // also update here syncronously
                        setLinkedObjectsList(newLinkedObjects);
                    }



                }
            }

            if (!updatedNewLinkedObjects)
                setLinkedObjectsList(newLinkedObjects);

            // Show add task popup
            setVisibleAddTaskPopup(true);
        }
    };












    /*
     * This method is just static names for entity types that aren't initially fetched when getting the menu like for example "systematic-review-item"
     * */
    const getStaticEntityTypeName = (entityType) => {

        let entityName = "";

        switch (entityType) {
            case "systematic-review-item": entityName = "Systematic Review Item"; break;
            case "product": entityName = "Products"; break;
            case "countryregistration": entityName = "Country Registrations"; break;
            case "compliance": entityName = "Compliance Manager"; break;
            default: entityName = "";
        }

        return entityName;

    }

    const getEntity = async (EntityType, EntityId) => {

        return new Promise((resolve, reject) => {

            let getEntityURL =
                `/umbraco/api/TaskManagerApi/Entity?` +
                `entityType=${encodeURIComponent(EntityType)}&` +
                `entityId=${encodeURIComponent(EntityId)}&`;

            fetch(getEntityURL)
                .then((response) => {
                    if (!response.ok) {
                        if (response.status === 401)
                            document.dispatchEvent(new Event("api:unauthorized"));

                        throw new Error("Network response was not ok");
                    }
                    return response.json();
                })
                .then((data) => {

                    let newLinkedObject = {};

                    if (data.Name != undefined) {
                        newLinkedObject = {
                            EntityName: data.Name,
                            EntityType: data.EntityType,
                            EntityId: data.EntityId,
                            EntityUrl: data.Url,
                            Icon: ""
                        };

                        resolve(newLinkedObject);
                    }

                })
                .catch((error) => {
                    // Handle any errors that occurred during the fetch
                    console.log("error: " + error);
                })
                .finally(() => {
                    resolve(null);
                });

        });


    }



    /*
        When in the task view/edit pane, when you click a field this will set edit mode on for that field
    */
    const enableTaskFormFieldEdit = (field, e) => {
        e.stopPropagation();
        let newObj = { ...isEditingField, [field]: true };
        setIsEditingField(newObj);
    };

    /*
                                          Disable all editable fields in the view/edit form
                                         */
    const disableAllTaskFormFieldsEdit = () => {
        let newObj = { ...isEditingField };
        for (let prop in newObj) {
            newObj[prop] = false;
        }
        setIsEditingField(newObj);
    };

    /*
                                          Returns the user object with the requested id
                                        */
    const getUserById = (id) => {
        return users.find((item) => item.Id == id);
    };

    /*
                                          Returns the priority object with the requested id
                                        */
    const getPriorityById = (id) => {
        return priorities.find((item) => item.id == id);
    };

    /*
                            Returns the completeness object with the requested id
                          */
    const getCompletenessById = (id) => {
        return completeness.find((item) => item.id == id);
    };

    /*
                            Returns the boardstep object with the requested id
                          */
    const getBoardStepById = (id) => {
        return boards[0]?.Steps.find((item) => item.BoardStepId == id);
    };

    /*
                                          Convert: Wed Aug 30 2023 00:00:00 GMT+0100 (Western European Summer Time) 
                                          To: 2023-08-30
                                         */

    const formatDate = (dateStr, includeTime=false) => {
        const dateObj = new Date(dateStr);
        const year = dateObj.getFullYear();
        const month = String(dateObj.getMonth() + 1).padStart(2, "0"); // Month is zero-indexed
        const day = String(dateObj.getDate()).padStart(2, "0");

        let time = "";
        if (includeTime) {
            let hours = (dateObj.getHours() < 10 ? '0' : '') + dateObj.getHours();
            let minutes = (dateObj.getMinutes() < 10 ? '0' : '') + dateObj.getMinutes();

            time = ` ${hours}:${minutes}`;
        }

        const formattedDate = `${year}-${month}-${day}${time}`;
        return formattedDate;
    };

    /*
                                          Convert: 2023-08-30
                                          To: Wed Aug 30 2023 00:00:00 GMT+0100 (Western European Summer Time) 
                                         */

    const unformatDate = (dateStr) => {
        const parts = dateStr.split("-");
        const year = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1; // Month is zero-indexed
        const day = parseInt(parts[2], 10);
        const dateObject = new Date(year, month, day);

        return dateObject;
    };

    

    const saveBoardConfiguration = (newBoardSteps) => {
        let saveBoardURL = "/umbraco/api/TaskManagerApi/Board";

        // Create new board object to replace temporary negative ids of new steps by 0 for backend
        let boardToSave = JSON.parse(JSON.stringify(boards[0]));
        boardToSave.Steps = newBoardSteps;
        boardToSave.Steps.map((item) => {
            if (item.BoardStepId < 0) item.BoardStepId = 0;
            return item;
        });

        const requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(boardToSave)
        };

        setIsSavingBoard(true);

        fetch(saveBoardURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => { })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
            })
            .finally(() => {
                loadBoards();
            });
    };

    

    //const taskListDivRef = useRef(null);
    //const taskListObserverRef = useRef(null);

    ///* The following code and useEffects are used to load more items into the task list
    //                until the div that shows them has a scrollbar (or no more rows available).
    //                This is important because the "scroll to load more" mechanism below this part only 
    //                works if there is a scrollbar to trigger the load more. If the initial loading of 
    //                tasks didn't load enough rows to create a scrollbar then there is no scrollbar to
    //                trigger the load more and no more tasks will be loaded after the first load. This 
    //                mainly happens in larger screens and if the number of items per page in the load is
    //                small. This will keep loading items until there are no more items or until there is 
    //                a scrollbar available. After that the "scroll to load more" mechanism works normally.
    //               */

    //const handleIntersectTaskList = useCallback(
    //    (entries, observer) => {
    //        // Check if the sentinel element is intersecting, and if so, call the load function
    //        let div = taskListDivRef.current;
    //        let hasScrollBar = div.scrollHeight > div.clientHeight;

    //        if (
    //            //entries[0].isIntersecting &&
    //            hasMoreData &&
    //            !hasScrollBar &&
    //            !isLoadingTasks &&
    //            !isLoadingSubTasks
    //        ) {
    //            /*
    //                                                                    console.log(
    //                                                                      "Loads more tasks because entries[0].isIntersecting=" +
    //                                                                        entries[0].isIntersecting +
    //                                                                        ", hasMoreData=" +
    //                                                                        hasMoreData +
    //                                                                        ", hasScrollBar=" +
    //                                                                        hasScrollBar +
    //                                                                        ", tasks.length=" +
    //                                                                        tasks.length
    //                                                                    );
    //                                                                    */
    //            console.log("handleIntersectTaskList signal");
    //            loadTasks({ nextPage: true });
    //        }
    //    },
    //    [loadTasks]
    //);

    //useEffect(() => {
    //    // Create a new IntersectionObserver when the component mounts
    //    taskListObserverRef.current = new IntersectionObserver(
    //        handleIntersectTaskList,
    //        {
    //            root: null,
    //            rootMargin: "0px",
    //            threshold: 1.0
    //        }
    //    );

    //    // Attach the observer to the sentinel element
    //    if (taskListDivRef.current) {
    //        taskListObserverRef.current.observe(taskListDivRef.current);
    //    }

    //    // Clean up the observer when the component unmounts
    //    return () => {
    //        if (taskListObserverRef.current) {
    //            taskListObserverRef.current.disconnect();
    //        }
    //    };
    //}, [loadTasks]);

    //useEffect(() => {
    //    // When the hasMore prop changes, disconnect the previous observer and reattach it to the new sentinel element
    //    if (taskListObserverRef.current && taskListDivRef.current) {
    //        taskListObserverRef.current.disconnect();
    //        taskListObserverRef.current.observe(taskListDivRef.current);
    //    }
    //}, [hasMoreData]);

    

    /* The useEffect below will control the scroll to load more rows on the tasks list.
                  This only works if the code above (the observers) work correctly to first
                  load sufficient items in order for that to be a scrollbar available.
              */

    /* useEffect for the main task list scroll */

    //useEffect(() => {
    //    const handleScrollTasksDiv = () => {
    //        const div = taskListDivRef.current;
    //        if (div) {
    //            const threshold = 20;
    //            const isBottom =
    //                div.scrollTop + threshold >= div.scrollHeight - div.clientHeight;

    //            if (isBottom && !isLoadingTasks && !isLoadingSubTasks && hasMoreData) {
    //                //console.log("LOAD MORE");
    //                setIsLoadingTasks(true);
    //                console.log("handleScrollTasksDiv signal");
    //                loadTasks({ nextPage: true });
    //            }
    //        }
    //    };

    //    const div = taskListDivRef.current;

    //    if (div) {
    //        div.addEventListener("scroll", handleScrollTasksDiv);
    //    }

    //    return () => {
    //        // Remove listener for scroll
    //        if (div) div.removeEventListener("scroll", handleScrollTasksDiv);
    //    };
    //});

    /*
              useEffect(() => {
                if (tasks.length > 0) {
                  if (!isTaskListVisible) setIsTaskListVisible(true);
                } else setIsTaskListVisible(false);
              }, [tasks]);
            */

    const changeTaskListOrderField = (field) => {
        let newOrderByType = "ASCENDING";

        if (field == taskListSortByField) {
            if (taskListSortByType == "ASCENDING") newOrderByType = "DESCENDING";
            setTaskListSortByType(newOrderByType);
        } else {
            setTaskListSortByType("ASCENDING");
            setTaskListSortByField(field);
        }

        loadTasks({
            localSortType: newOrderByType,
            localSortBy: field
        });
    };

    

    const changeShowTasksFilter = (filter) => {
        loadTasks({ localShowAssignedTo: filter, nextPage: false });
        setShowAssignedTo(filter);
    };

    const readableDate = (inputDate, showYear = false) => {
        const date = new Date(inputDate);

        const monthNames = [
            "Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ];

        const month = monthNames[date.getUTCMonth()];
        const day = date.getUTCDate();
        const year = date.getUTCFullYear();

        return `${day} ${month}${showYear ? ` ${year}` : ""}`;
    };


    const formatDateFromDatePicker = (date) => {

        // Create a Date object from the input string
        const dateObj = new Date(date);

        // Get the year, month, and day components from the Date object
        const year = dateObj.getFullYear();
        const month = String(dateObj.getMonth() + 1).padStart(2, '0'); // Months are 0-based, so add 1
        const day = String(dateObj.getDate()).padStart(2, '0');

        // Create the formatted date string
        const formattedDateString = `${year}-${month}-${day}`;

        return formattedDateString;
    }



    const followTask = (taskId, status) => {

        let followUrl = `/umbraco/api/TaskManagerApi/Follow?`+
            `follow=${encodeURIComponent(status)}&`+
            `taskId=${encodeURIComponent(taskId)}&`;

        const requestOptions = {
            method: "POST",
        };

        setIsProcessingFollow(true);

        fetch(followUrl, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
                if (data) {

                    // Remove user from follow list
                    let newFollowers = currentTask.Followers.filter(item => item !== currentUserId);
                    currentTask.Followers = newFollowers

                    // Re add if action was a follow
                    if(status == true)
                        currentTask.Followers.push(currentUserId);

                    let updatedTask = { ...currentTask };

                    setCurrentTask(updatedTask);
                }
            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
            })
            .finally(() => {
                setIsProcessingFollow(false);
            });

    }



    /* List of functions and elements available in the app context */
    let globalContext = {};
    globalContext.loadMenu = loadMenu;
    globalContext.taskView = taskView;
    globalContext.setTaskView = setTaskView;
    globalContext.taskSearchText = taskSearchText;
    globalContext.setTaskSearchText = setTaskSearchText;
    globalContext.showAddTaskPopup = showAddTaskPopup;
    globalContext.addTaskName = addTaskName;
    globalContext.setAddTaskName = setAddTaskName;
    globalContext.setAddTaskDescription = setAddTaskDescription;
    globalContext.addTaskDescription = addTaskDescription;
    globalContext.addTaskAssignedTo = addTaskAssignedTo;
    globalContext.setAddTaskAssignedTo = setAddTaskAssignedTo;
    globalContext.users = users;
    globalContext.addTaskStartDate = addTaskStartDate;
    globalContext.setAddTaskStartDate = setAddTaskStartDate;
    globalContext.addTaskEndDate = addTaskEndDate;
    globalContext.setAddTaskEndDate = setAddTaskEndDate;
    globalContext.addTask = addTask;
    globalContext.linkedObjectsList = linkedObjectsList;
    globalContext.setLinkedObjectsList = setLinkedObjectsList;
    globalContext.isPaneOpen = isPaneOpen;
    globalContext.closePane = closePane;
    globalContext.getPriorityById = getPriorityById;
    globalContext.priorities = priorities;
    globalContext.getCompletenessById = getCompletenessById;
    globalContext.completeness = completeness;
    globalContext.isEditingField = isEditingField;
    globalContext.enableTaskFormFieldEdit = enableTaskFormFieldEdit;
    globalContext.currentTask = currentTask;
    globalContext.disableAllTaskFormFieldsEdit = disableAllTaskFormFieldsEdit;
    globalContext.setCurrentTask = setCurrentTask;
    globalContext.unformatDate = unformatDate;
    globalContext.formatDate = formatDate;
    globalContext.getBoardStepById = getBoardStepById;
    globalContext.isSavingTask = isSavingTask;
    globalContext.saveCurrentTask = saveCurrentTask;
    globalContext.isDeletingTask = isDeletingTask;
    globalContext.deleteCurrentTask = deleteCurrentTask;
    globalContext.isShowingDeleteConfirmation = isShowingDeleteConfirmation;
    globalContext.setIsShowingDeleteConfirmation = setIsShowingDeleteConfirmation;
    globalContext.tasks = tasks;
    globalContext.setTasks = setTasks;
    globalContext.isLoadingTasks = isLoadingTasks;
    globalContext.setIsLoadingTasks = setIsLoadingTasks;
    globalContext.isLoadingSubTasks = isLoadingSubTasks;
    globalContext.setIsLoadingSubTasks = setIsLoadingSubTasks;
    globalContext.loadTaskDetails = loadTaskDetails;
    globalContext.getUserById = getUserById;
    globalContext.boards = boards;
    globalContext.useDummy = useDummy;
    globalContext.togglePane = togglePane;
    globalContext.loadTasks = loadTasks;
    globalContext.loadSubTasks = loadSubTasks;
    globalContext.loadedSubTasksForTaskId = loadedSubTasksForTaskId;
    globalContext.setLoadedSubTasksForTaskId = setLoadedSubTasksForTaskId;
    globalContext.saveBoardConfiguration = saveBoardConfiguration;
    globalContext.isSavingBoard = isSavingBoard;
    globalContext.menu = menu;
    globalContext.fullMenuObject = fullMenuObject;
    globalContext.currentEntityType = currentEntityType;
    globalContext.setCurrentEntityType = setCurrentEntityType;
    globalContext.currentEntityId = currentEntityId;
    globalContext.setCurrentEntityId = setCurrentEntityId;
    globalContext.currentTaskListPage = currentTaskListPage;
    globalContext.setCurrentTaskListPage = setCurrentTaskListPage;
    globalContext.hasMoreData = hasMoreData;
    //globalContext.taskListDivRef = taskListDivRef;
    globalContext.taskListSortByField = taskListSortByField;
    globalContext.setTaskListSortByField = setTaskListSortByField;
    globalContext.defaultTaskListSortByField = defaultTaskListSortByField;
    globalContext.defaultTaskListSortByType = defaultTaskListSortByType;
    globalContext.taskListSortByType = taskListSortByType;
    globalContext.setTaskListSortByType = setTaskListSortByType;
    globalContext.changeTaskListOrderField = changeTaskListOrderField;
    globalContext.isShowingSaveMessage = isShowingSaveMessage;
    globalContext.setIsShowingSaveMessage = setIsShowingSaveMessage;
    globalContext.changeShowTasksFilter = changeShowTasksFilter;
    globalContext.showAssignedTo = showAssignedTo;
    globalContext.isLoadingTaskCountSummary = isLoadingTaskCountSummary;
    globalContext.taskCountSummary = taskCountSummary;
    globalContext.showAllFields = showAllFields;
    globalContext.setShowAllFields = setShowAllFields;
    globalContext.addTaskEntityTypesList = addTaskEntityTypesList;
    globalContext.checkHasIncompleteSubtasks = checkHasIncompleteSubtasks;
    globalContext.isSlimVersion = isSlimVersion;
    globalContext.whereAmI = whereAmI;
    globalContext.setWhereAmI = setWhereAmI;
    globalContext.isLoadingMenu = isLoadingMenu;
    globalContext.windowSpacing = windowSpacing;
    globalContext.breadcrumbs = breadcrumbs;
    globalContext.isAddingTask = isAddingTask;
    globalContext.errorAddTaskName = errorAddTaskName;
    globalContext.errorAddTaskDescription = errorAddTaskDescription;
    globalContext.errorAddTaskStartDate = errorAddTaskStartDate;
    globalContext.errorAddTaskEndDate = errorAddTaskEndDate;
    globalContext.errorCurrentTaskName = errorCurrentTaskName;
    globalContext.errorCurrentTaskDescription = errorCurrentTaskDescription;
    globalContext.errorCurrentTaskStartDate = errorCurrentTaskStartDate;
    globalContext.errorCurrentTaskEndDate = errorCurrentTaskEndDate;
    globalContext.validFormField = validFormField;
    globalContext.setErrorCurrentTaskName = setErrorCurrentTaskName;
    globalContext.setErrorCurrentTaskDescription = setErrorCurrentTaskDescription;
    globalContext.setErrorCurrentTaskStartDate = setErrorCurrentTaskStartDate;
    globalContext.setErrorCurrentTaskEndDate = setErrorCurrentTaskEndDate;
    globalContext.doTextSearchTask = doTextSearchTask;
    globalContext.clearEntitySearchResults = clearEntitySearchResults;
    globalContext.readableDate = readableDate;
    globalContext.getStaticEntityTypeName = getStaticEntityTypeName;
    globalContext.isEditingFilterCompleteIncomplete = isEditingFilterCompleteIncomplete;
    globalContext.setIsEditingFilterCompleteIncomplete = setIsEditingFilterCompleteIncomplete;
    globalContext.filterCompleteIncomplete = filterCompleteIncomplete;
    globalContext.isLoadingTaskDetails = isLoadingTaskDetails;
    globalContext.formatDateFromDatePicker = formatDateFromDatePicker;
    globalContext.completionStatus = completionStatus;
    globalContext.setCompletionStatus = setCompletionStatus;
    globalContext.possibleCompletionStatus = possibleCompletionStatus;
    globalContext.currentUserId = currentUserId;
    globalContext.taskHasMoreComments = taskHasMoreComments;
    globalContext.setTaskHasMoreComments = setTaskHasMoreComments;
    globalContext.comments = comments;
    globalContext.setComments = setComments;
    globalContext.commentsPage = commentsPage;
    globalContext.setCommentsPage = setCommentsPage;
    globalContext.addTaskRecurrency = addTaskRecurrency;
    globalContext.setAddTaskRecurrency = setAddTaskRecurrency;
    globalContext.errorAddTaskRecurrencyEndDate = errorAddTaskRecurrencyEndDate;
    globalContext.setErrorAddTaskRecurrencyEndDate = setErrorAddTaskRecurrencyEndDate;
    globalContext.addTaskRecurrencyEndDate = addTaskRecurrencyEndDate;
    globalContext.setAddTaskRecurrencyEndDate = setAddTaskRecurrencyEndDate;
    globalContext.recurrences = recurrences;
    globalContext.setRecurrences = setRecurrences;
    globalContext.visibleTaskDetailsTab = visibleTaskDetailsTab;
    globalContext.setVisibleTaskDetailsTab = setVisibleTaskDetailsTab;
    globalContext.isLoadingPaneSubTasks = isLoadingPaneSubTasks;
    globalContext.setIsLoadingPaneSubTasks = setIsLoadingPaneSubTasks;
    globalContext.currentSubTasksList = currentSubTasksList;
    globalContext.setCurrentSubTasksList = setCurrentSubTasksList;
    globalContext.alreadyLoadedSubTasks = alreadyLoadedSubTasks;
    globalContext.setAlreadyLoadedSubTasks = setAlreadyLoadedSubTasks;
    globalContext.addTaskParentTaskId = addTaskParentTaskId;
    globalContext.setAddTaskParentTaskId = setAddTaskParentTaskId;
    globalContext.reloadSubTasks = reloadSubTasks;
    globalContext.setReloadSubTasks = setReloadSubTasks;
    globalContext.errorLoadingTaskDetails = errorLoadingTaskDetails;
    globalContext.setErrorLoadingTaskDetails = setErrorLoadingTaskDetails;
    globalContext.notifyUser = notifyUser;
    globalContext.setNotifyUser = setNotifyUser;
    globalContext.changedAssignee = changedAssignee;
    globalContext.setChangedAssignee = setChangedAssignee;
    globalContext.hasLimitedWidth = hasLimitedWidth;
    globalContext.showHeaderlessCountSummaries = showHeaderlessCountSummaries;
    globalContext.followTask = followTask;
    globalContext.isProcessingFollow = isProcessingFollow;
    globalContext.setIsProcessingFollow = setIsProcessingFollow;
    globalContext.isReviewApproved = isReviewApproved;
    globalContext.reachedAllowance = reachedAllowance;
    globalContext.showRefreshLastLoadData = showRefreshLastLoadData;
    globalContext.setShowRefreshLastLoadData = setShowRefreshLastLoadData;
    globalContext.showBreadcrumbs = showBreadcrumbs;
    globalContext.showWhereAmI = showWhereAmI;

    // When a user clicks outside of any element in the main area
    const handleOutsideClick = () => {
        // Close task details pane
        closePane();

    };


    // Originally: finalWindowHeight = windowHeight + "px"
    // Try this
    let finalWindowHeight = "calc(100vh - 74px)";

    return (
        <TaskManagerAppContext.Provider value={globalContext}>
            <div onClick={handleOutsideClick} className="App" style={{ height: finalWindowHeight }} >
                <div style={{ display: "flex", flexDirection: "row", height: finalWindowHeight }}>

                    {!isSlimVersion && showLeftMenu && (
                        <>
                            <TaskManagerMenu
                                menu={menu}
                                style={{
                                    minWidth: "20%", maxWidth: "20%",
                                    /*marginRight: "20px",*/
                                    /*maxHeight: `calc(100vh - 100px)`,*/
                                    overflowY: "auto",
                                    paddingRight: "10px",
                                    paddingLeft: "10px",
                                    backgroundColor: "#fdfdfe",
                                    borderLeft: "0px solid #f0f0f0",
                                    borderRight: "1px solid #f0f0f0",
                                }}
                            />
                        </>
                    )}
                    
                    <TaskManagerContent style={isSlimVersion || !showLeftMenu ? { flex: 1 } : { paddingLeft: "10px", minWidth: "80%", maxWidth: "80%", }} />
                </div>
            </div>

            <TaskDetailsPane />

            {visibleAddTaskPopup && <AddTaskPopup />}
        </TaskManagerAppContext.Provider>
    );
};

const TaskManagerMenu = ({ menu, style }) => {
    const AppContext = useContext(TaskManagerAppContext);

    let fullMenuObject = AppContext.fullMenuObject;

    return (
        <>
            {AppContext.isLoadingMenu ? (
                <>
                    <div style={{ ...style, textAlign: "center" }}>
                        <LoadingSpinnerImage />
                    </div>
                </>
            ) : (
                <>
                    {/* TOP LEVEL CATEGORY */}

                    <div className="thin-scrollbar" style={{ ...style }}>

                            {fullMenuObject && fullMenuObject.EntityType != null ?
                                <div style={{ display: "flex" }}>
                                    <div
                                        className="menu-item-row"
                                        style={{
                                            cursor: "pointer",
                                            display: "flex",
                                            flexDirection: "row",
                                            textAlign: "left",
                                            padding: "6px 10px",
                                            borderRadius: "10px",
                                            height: "40px",
                                            alignItems: "center",
                                            borderRadius: "15px",
                                            border: "1px solid silver",
                                            color: "#203864",
                                            flex: "0 0 auto",
                                        }}
                                        onClick={() => {
                                            if (!AppContext.isLoadingTasks && !AppContext.isLoadingSubTasks) {
                                                AppContext.setWhereAmI("All Tasks");
                                                AppContext.loadMenu(null, null);
                                            }
                                        }}
                                    >
                                    <b><i className="fas fa-arrow-left"></i> Go Back to All Tasks</b>
                                </div>
                            </div>
                            :
                            <div><b>Task Manager Menu</b></div>
                            }

                            
                        <br/>
                        <br />

                        {/* CATEGORY NAME */}

                        {fullMenuObject && fullMenuObject.EntityType != null &&

                            <div>
                                
                                <div style={{ width: "100%" }}>
                                    <hr style={{ borderColor: "#f0f0f0" }} />
                                </div>
                                

                                <div
                                    className="menu-item-row"
                                    style={{
                                        cursor: "pointer",
                                        display: "flex",
                                        flexDirection: "row",
                                        textAlign: "left",
                                        padding: "6px",
                                        borderRadius: "10px",
                                        alignItems: "center",
                                        height: "50px",
                                        color: "#203864",

                                        ...(AppContext.currentEntityId == null ? { color: "#0052cc", backgroundColor: "#f1f1f1", } : "")

                                    }}
                                >
                                    <div
                                        onClick={() => {
                                            if (!AppContext.isLoadingTasks && !AppContext.isLoadingSubTasks) {
                                                AppContext.setWhereAmI(fullMenuObject.Title);
                                                AppContext.loadMenu(fullMenuObject.EntityType, fullMenuObject.EntityId);
                                            }
                                        }}
                                        style={{ flex: 1, fontWeight: "bold" }}
                                        >
                                            <EntityTypeIcon entityType={fullMenuObject.EntityType} /> {fullMenuObject.Title}
                                    </div>
                                    <div>
                                        <span
                                            style={{
                                                fontSize: "9pt",
                                                borderRadius: "15px",
                                                backgroundColor: "#f0f0f0",
                                                padding: "0px 9px"
                                            }}
                                        >
                                            {fullMenuObject.Count}
                                        </span>
                                    </div>
                                </div>
                                
                            </div>

                        }


                        {/* ITEMS */}

                        {menu.map((item, index) => (
                            <div key={index}>
                                {item.IsGroupHeader && (
                                    <div style={{ width: "100%" }}>
                                        <hr style={{ borderColor: "#f0f0f0" }} />
                                    </div>
                                )}

                                <div
                                    className="menu-item-row"
                                    key={index}
                                    style={{
                                        cursor: "pointer",
                                        display: "flex",
                                        flexDirection: "row",
                                        textAlign: "left",
                                        padding: "6px",
                                        borderRadius: "10px",
                                        alignItems: "center",
                                        color: "#203864",

                                        ...(item.IsGroupHeader ? { height: "50px" } : ""),
                                        ...(item.IsGroupHeader && (item.EntityType == AppContext.currentEntityType || (item.EntityType == "" && AppContext.currentEntityType == null)) ? { color: "#0052cc", backgroundColor: "#f1f1f1" } : ""),
                                        ...(item.EntityId == AppContext.currentEntityId && AppContext.currentEntityId != null ? { color: "#0052cc", backgroundColor: "#f1f1f1", } : "")

                                    }}
                                >
                                    <div
                                        onClick={() => {
                                            if (!AppContext.isLoadingTasks && !AppContext.isLoadingSubTasks) {
                                                AppContext.setWhereAmI(item.Name);
                                                AppContext.loadMenu(item.EntityType, item.EntityId);
                                            }
                                        }}
                                        style={{ flex: 1, ...(item.IsGroupHeader ? { fontWeight: "bold" } : { marginLeft: "10px" } ) }}
                                    >

                                        {item.IsGroupHeader && <EntityTypeIcon entityType={item.EntityType} />}
                                        {item.Name}
                                        {item.HasChildren && <i style={{ marginLeft: "10px", color: "#aaa", fontSize: "0.8em" }} className="fas fa-chevron-right"></i>}
                                    </div>
                                    <div>
                                        <span
                                            style={{
                                                fontSize: "9pt",
                                                borderRadius: "15px",
                                                backgroundColor: "#f0f0f0",
                                                padding: "0px 9px"
                                            }}
                                        >
                                            {item.ItemCount}
                                        </span>
                                    </div>
                                </div>

                                {/* Add "View tasks by" below "All Tasks" option */}

                                {(item.EntityId == null && item.EntityType == "" ? <>

                                    <div style={{height: "50px", display: "flex", alignItems: "center"}}>
                                        <b>View Tasks By:</b>
                                    </div>

                                </> : "")}

                            </div>
                        ))}

                        <br />
                    </div>
                </>
            )}
        </>
    );
};

const TaskManagerContent = ({ style }) => {
    const AppContext = useContext(TaskManagerAppContext);

    return (
        <>
            <div style={{ display: "flex", flexDirection: "column", ...style }}>
                <Header />
                
                {AppContext.taskView == "table" && <TaskManagerTable />}
                {AppContext.taskView == "board" && <BoardView />}
                {AppContext.taskView == "board-configuration" && <BoardConfiguration />}
            </div>
        </>
    );
};

const Header = () => {
    const AppContext = useContext(TaskManagerAppContext);

    const currentCompletionStatusRef = useRef(null);

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "row",
                marginBottom: "20px"
            }}
        >
            <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                {!AppContext.isSlimVersion ?
                    <>

                        {AppContext.showBreadcrumbs ?
                            <div style={{ width: "100%" }}>
                                <Breadcrumbs />
                            </div>
                        : null}

                        {AppContext.showWhereAmI ? 

                            <div style={{ width: "100%", textAlign: "left" }}>
                                <h3 style={{ color: "#203864" }}>
                                    <EntityTypeIcon entityType={AppContext.currentEntityType} />
                                    <EntityTypeLink><span style={{ marginLeft: "10px" }}>{AppContext.whereAmI}</span></EntityTypeLink>
                                </h3>
                            </div>

                        : null}

                        {/* TASKS SUMMARY */}

                        <CountSummaries />

                    </>
                    :
                    <>
                        {AppContext.showHeaderlessCountSummaries ?
                            <CountSummaries />
                            :
                            null
                        }
                    </>
                }


                


                {/* DISPLAY VIEW */}

                <div
                    style={{
                        display: "flex",
                        width: "100%",
                        flexDirection: "row",
                        marginBottom: "15px"
                    }}
                >
                    <div
                        style={{
                            cursor: "pointer",
                            paddingBottom: "3px",
                            paddingRight: "10px",
                            ...(AppContext.taskView == "table"
                                ? { borderBottom: "2px solid #00abff" }
                                : { borderBottom: "2px solid #f0f0f0" })
                        }}
                        onClick={() => AppContext.setTaskView("table")}
                    >
                        <i className="fas fa-table"></i> Table View
                    </div>

                    <div
                        style={{
                            cursor: "pointer",
                            paddingRight: "10px",
                            paddingLeft: "5px",
                            ...(AppContext.taskView == "board" ||
                                AppContext.taskView == "board-configuration"
                                ? { borderBottom: "2px solid #00abff" }
                                : { borderBottom: "2px solid #f0f0f0" })
                        }}
                        onClick={() => AppContext.setTaskView("board")}
                    >
                        <i className="fas fa-columns"></i> Board View
                    </div>

                    <div style={{ flex: 1, borderBottom: "2px solid #f0f0f0" }}></div>
                </div>

                {/* CONTENT */}

                <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
                    <div
                        style={{
                            display: "flex",
                            flexGrow: 1,
                            alignItems: "center"
                        }}
                    >
                        {/* Search */}

                        <div className="search-input">
                            <span className="search-icon">
                                <i className="fas fa-search"></i>
                            </span>
                            <input
                                placeholder="Search name, description or assignee"
                                value={AppContext.taskSearchText}
                                onChange={(e) => {
                                    if (!AppContext.isLoadingTasks && !AppContext.isLoadingSubTasks) {
                                        let text = e.target.value;
                                        AppContext.setTaskSearchText(text);
                                        AppContext.doTextSearchTask({ localSearch: text });
                                    }
                                }}
                            />
                        </div>

                        {/* User Filter */}

                        <div
                            style={{
                                marginLeft: "20px",
                                display: "flex",
                                flexDirection: "row"
                            }}
                        >
                            <span
                                title="Show only my tasks"
                                onClick={() => {
                                    if (!AppContext.isLoadingTasks && !AppContext.isLoadingSubTasks) {
                                        AppContext.changeShowTasksFilter("Me");
                                    }
                                }}
                                className={`show-tasks-mine ${AppContext.showAssignedTo == "Me"
                                    ? ""
                                    : "show-tasks-mine-unselected"
                                    }`}
                            >
                                <i className="fas fa-user"></i>
                            </span>
                            <span
                                title="Show everyone's tasks"
                                onClick={() => {
                                    if (!AppContext.isLoadingTasks && !AppContext.isLoadingSubTasks) {
                                        AppContext.changeShowTasksFilter("Company");
                                    }
                                }}
                                className={`show-tasks-team ${AppContext.showAssignedTo == "Company"
                                    ? ""
                                    : "show-tasks-team-unselected"
                                    }`}
                            >
                                <i className="fas fa-users"></i>
                            </span>
                        </div>

                        {/* Complete/Incomplete Filter */}

                        <div style={{
                            marginLeft: "20px",
                            flexDirection: "row",
                        }}>
                            {AppContext.isEditingFilterCompleteIncomplete ? <>
                                <select ref={currentCompletionStatusRef} value={AppContext.completionStatus} onChange={(e) => {
                                    let value = e.target.value;
                                    AppContext.setCompletionStatus(value);
                                    AppContext.setIsEditingFilterCompleteIncomplete(false);
                                    AppContext.loadTasks({ localCompletionStatus: value });
                                }}
                                    onBlur={() => {
                                        AppContext.setIsEditingFilterCompleteIncomplete(false);
                                    }}
                                >
                                    {AppContext.possibleCompletionStatus.map((item, index) =>
                                        <option key={index} value={item.value}>{item.name}</option>
                                    )}
                                </select>

                            </> : <>

                                    <span onClick={(e) => {
                                        if (!AppContext.isLoadingTasks && !AppContext.isLoadingSubTasks) {
                                            AppContext.setIsEditingFilterCompleteIncomplete(true);
                                        }
                                    }}><CompletionStatus value={AppContext.completionStatus} /></span>

                            </>}
                        </div>

                        {/* Board Configuration */}

                        {(AppContext.taskView == "board") && (
                            <div
                                style={{ marginLeft: "20px" }}
                                onClick={() => AppContext.setTaskView("board-configuration")}
                            >
                                <span className="action-button board-config-button">
                                    <i className="fas fa-cog"></i> Board Configuration
                                </span>
                            </div>
                        )}

                        {(AppContext.taskView == "board-configuration") && (
                            <div
                                style={{ marginLeft: "20px" }}
                                onClick={() => AppContext.setTaskView("board")}
                            >
                                <span className="action-button board-config-button">
                                    <i className="fas fa-columns"></i> Board View
                                </span>
                            </div>
                        )}
                    </div>

                    {/* Add Task */}


                    {AppContext.reachedAllowance ? <>

                        <span>
                            <span className="action-button add-task-button" style={{backgroundColor: "#c0c0c0", cursor: "help"}} title="Allowance limit reached. Contact MedBoard to increase the limit.">
                                <i className="fas fa-plus-circle g-mr-5"></i> Add Task
                            </span>
                        </span>

                    </> : <>

                        <div
                            style={{
                                display: "flex",
                                textAlign: "center",
                                justifyContent: "center",
                                alignItems: "center"
                            }}
                        >
                            <span onClick={() => { AppContext.setAddTaskParentTaskId(null); AppContext.showAddTaskPopup(); }}
                                style={{ display: AppContext.isReviewApproved ? "none" : "inline" }}
                            >
                                <span className="action-button add-task-button task-manager-primary-add-task-button">
                                    <i className="fas fa-plus-circle"></i> Add Task
                                </span>
                            </span>
                        </div>

                    </>}



                </div>  
            </div>
        </div>
    );
};


const EntityTypeIcon = ({ entityType }) => {

    let finalClass = "far fa-calendar-check";
    let iconFound = "";

    let icons = [
        { entityType: "systematic-review-clinical",         class: "fas fa-file-signature" },
        { entityType: "systematic-review-marketpms",        class: "fas fa-file-signature" },
        { entityType: "systematic-review-regulatory",       class: "fas fa-file-signature" },
        { entityType: "systematic-review",                  class: "fas fa-file-signature" },
        { entityType: "systematic-review-group",            class: "fas fa-file-signature" },
        { entityType: "product",                            class: "fas fa-box-open" },
        { entityType: "product-family",                     class: "fas fa-box-open" },
        { entityType: "product-skus",                       class: "fas fa-box-open" },
        { entityType: "countryregistration",                class: "fas fa-clipboard-list" },
        { entityType: "countryregistration-country",        class: "fas fa-clipboard-list" },
        { entityType: "countryregistration-certificate",    class: "fas fa-clipboard-list" },
        { entityType: "countryregistration-registration",   class: "fas fa-clipboard-list" },
        { entityType: "countryregistration-operator",       class: "fas fa-clipboard-list" },
        { entityType: "compliance",                         class: "fas fa-shield-alt" },
        { entityType: "compliance-qms",                     class: "fas fa-shield-alt" },
        { entityType: "compliance-technical-documents",     class: "fas fa-shield-alt" },
    ];

    iconFound = icons.find((item) => item.entityType == entityType)?.class;

    if (iconFound)
        finalClass = iconFound;

    return (<>
        <i className={`g-mr-8 ${finalClass}`} />
    </>);


}


const EntityTypeLink = ({ children }) => {

    const AppContext = useContext(TaskManagerAppContext);

    let links = [
        { entityType: "systematic-review",                  name: "Systematic Reviews",                 url: "/your-medboard/systematic-reviews-menu/?area=0" },
        { entityType: "product-family",                     name: "Product Families",                   url: "/your-medboard/product-families/" },
        { entityType: "product-skus",                       name: "Products",                           url: "/your-medboard/products/" },
        { entityType: "countryregistration-certificate",    name: "RIMS Certificates",                  url: "/your-medboard/country-registrations/certificates/" },
        { entityType: "countryregistration-operator",       name: "RIMS Operators",                     url: "/your-medboard/country-registrations/operators/" },
        { entityType: "compliance-standards",               name: "Compliance Standards",               url: "/your-medboard/compliance-portfolio/standards/" },
        { entityType: "compliance-regulatorydocuments",     name: "Compliance Regulations",             url: "/your-medboard/compliance-portfolio/regulatory-documents/" },
        { entityType: "compliance-qms",                     name: "Compliance QMS",                     url: "/your-medboard/compliance-portfolio/qms-procedures/" },
        { entityType: "compliance-technical-documents",     name: "Compliance Technical Documentation", url: "/your-medboard/compliance-portfolio/technical-documentation/" },
    ];

    const link = links.find(l => l.entityType == AppContext.currentEntityType);

    //console.log("AppContext.paramEntityType", AppContext.currentEntityType);
    //console.log("AppContext.whereAmI", AppContext.whereAmI);

    return (<>
        {link && AppContext.whereAmI == "All Tasks" ? <>
            <a style={{marginLeft: "10px", marginRight: "10px"}} href={link.url}>{link.name}</a>- {children}
        </>
        :
        <>
            {children}
        </>
        }
    </>);

}



const CompletionStatus = ({ value, forTaskDetails = false, onlyIcon = false, }) => {

    const AppContext = useContext(TaskManagerAppContext);

    return (<>
        <span
            style={{
                ...(!onlyIcon ? {
                    padding: "7px 8px",
                    borderRadius: "5px",
                    border: "1px solid #c0c0c0",
                    cursor: "pointer"} : null),
                }}

        >
            {value == "All" ? <i className="far fa-check-circle"></i> : null}
            {value == "Incomplete" ? <i className="far fa-circle"></i> : null}
            {value == "Completed" ? <i className="fas fa-check-circle" style={{ color: "#00d084" }} ></i> : null}

            {!onlyIcon && 

                <span style={{ marginLeft: "5px" }}>
                    {
                        forTaskDetails ? <>{value}</> : <>{AppContext.possibleCompletionStatus.find((item) => item.value == value)?.name}</>
                    }
                </span>
            
            }

        </span>
    </>);
}


const CountSummaries = () => {
    const AppContext = useContext(TaskManagerAppContext);

    return (<>
        <div className="task-summary">
            <div className="task-summary-column">
                <div className="task-summary-block">
                    {AppContext.isLoadingTaskCountSummary ? (
                        <LoadingSpinnerImage />
                    ) : (
                        <>
                            <div className="task-summary-header">
                                    <i className="fas fa-user" style={{ color: "#3276b4", marginRight: "5px" }}></i> My Tasks:<span style={{ fontSize: "21px", color: "#3276b4", marginLeft: "5px" }}>{AppContext.taskCountSummary?.me?.total}</span>
                            </div>

                            <div className="details">
                                <span className="detail">
                                    <i className="fas fa-circle late"></i>
                                    <span><b>{AppContext.taskCountSummary?.me?.late ?? 0}</b> Late</span>
                                </span>
                                <span className="detail">
                                    <i className="fas fa-circle today"></i>
                                    <span><b>{AppContext.taskCountSummary?.me?.today ?? 0}</b> Today</span>
                                </span>
                                <span className="final-detail">
                                    <i className="fas fa-circle next7days"></i>
                                    <span><b>{AppContext.taskCountSummary?.me?.next7days ?? 0}</b> Next 7 days</span>
                                </span>
                            </div>
                        </>
                    )}
                </div>
            </div>
            <div className="task-summary-column">
                <div className="task-summary-block">
                    {AppContext.isLoadingTaskCountSummary ? (
                        <LoadingSpinnerImage />
                    ) : (
                        <>
                            <div className="task-summary-header">
                                    <i className="fas fa-users" style={{ color: "#3276b4", marginRight: "5px" }}></i> My Organization Tasks:<span style={{ fontSize: "21px", color: "#3276b4", marginLeft: "5px" }}>{AppContext.taskCountSummary?.company?.total}</span>
                            </div>

                            <div className="details">
                                <span className="detail">
                                    <i className="fas fa-circle late"></i>
                                    <span><b>{AppContext.taskCountSummary?.company?.late ?? 0}</b> Late</span>
                                </span>
                                <span className="detail">
                                    <i className="fas fa-circle today"></i>
                                    <span><b>{AppContext.taskCountSummary?.company?.today ?? 0}</b> Today</span>
                                </span>
                                <span className="final-detail">
                                    <i className="fas fa-circle next7days"></i>
                                    <span><b>{AppContext.taskCountSummary?.company?.next7days ?? 0}</b> Next 7 days</span>
                                </span>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>

    </>);

};

const Breadcrumbs = () => {
    let AppContext = useContext(TaskManagerAppContext);

    return (
        <>
            <div className="breadcrumbs">
                {AppContext.breadcrumbs?.map((item, index) => (
                    <span key={index}>
                        {index > 0 && <span> &gt; </span>}
                        <span
                            className="breadcrumb"
                            onClick={() => {
                                if (!AppContext.isLoadingTasks && !AppContext.isLoadingSubTasks) {
                                    if (index == 0)
                                        AppContext.setWhereAmI("All Tasks");
                                    else
                                        AppContext.setWhereAmI(item.Name);

                                    AppContext.loadMenu(item.EntityType, item.EntityId);
                                }
                            }}
                        >
                            {item.Name}
                        </span>
                    </span>
                ))}


                {AppContext.breadcrumbs?.length == 1 &&
                    <span>
                        <span> &gt; </span>
                        <span
                            className="breadcrumb"
                            onClick={() => {
                                if (!AppContext.isLoadingTasks && !AppContext.isLoadingSubTasks) {
                                    AppContext.setWhereAmI("All Tasks");
                                    AppContext.loadMenu(null, null);
                                }
                            }}
                        >
                            All Tasks
                        </span>
                    </span>
                }

                

                {AppContext.currentEntityId != null &&
                    <span>
                        <span> &gt; </span>
                        <span
                            className="breadcrumb"
                        >
                            {AppContext.whereAmI}
                        </span>
                    </span>
                }

            </div>
        </>
    );
};

const AddTaskPopup = () => {
    const AppContext = useContext(TaskManagerAppContext);
    const [isEntityAssociationExpanded, setIsEntityAssociationExpanded] = useState(false)

    
    return (

        <div style={{position: "fixed", backgroundColor: "rgba(1, 1, 1, 0.5)", height: "100%", width: "100%", top: 0, left: 0, zIndex: 1000, overflowY: "auto" }}>

            <div className="add-task-popup" style={AppContext.hasLimitedWidth ? { width: "70%"} : null}>
            <div style={{ display: "flex", flexDirection: "row", marginBottom: "5px" }}>
                <div style={{ width: "50%" }}>
                    <h3>{AppContext.addTaskParentTaskId ? "Add subtask" : "Add task"}</h3>
                </div>
                <div style={{ width: "50%", textAlign: "right" }}>
                    <button
                        className="close-button"
                        onClick={() => { AppContext.setAddTaskParentTaskId(null); AppContext.showAddTaskPopup(false); }}
                    >
                        <i className="fas fa-times"></i>
                    </button>
                </div>
            </div>

            {AppContext.addTaskParentTaskId && <>
                <br />
                <div style={{ fontStyle: "italic", width: "100%" }}>
                    <span style={{ fontWeight: "bold" }}>Main task:</span> {AppContext.tasks.find((item) => item.Id == AppContext.addTaskParentTaskId)?.Name}
                </div>
                <br />
            </>
            }

            <input
                value={AppContext.addTaskName}
                className={`form-field-text add-task-field-name ${AppContext.errorAddTaskName ? "form-field-error" : null
                    }`}
                onChange={(e) => AppContext.setAddTaskName(e.target.value)}
                style={{ width: "100%" }}
                type="text"
                placeholder={AppContext.addTaskParentTaskId ? "Subtask name" : "Task name"}
            />
            {AppContext.errorAddTaskName && (
                <span className="form-field-error-message">
                    This field is necessary
                </span>
            )}
            <br />
            <br />
            <textarea
                value={AppContext.addTaskDescription}
                className={`form-field-text add-task-field-description`}
                style={{ width: "100%" }}
                placeholder={AppContext.addTaskParentTaskId ? "Subtask description" : "Task description"}
                onChange={(e) => AppContext.setAddTaskDescription(e.target.value)}
            ></textarea>
            <br />
            <br />
            <div style={{ width: "100%", display: "flex", flexDirection: "row" }}>
                <div style={{ width: "33%" }}>
                    Assign to
                    <br />
                    <select
                        value={AppContext.addTaskAssignedTo}
                        onChange={(e) => AppContext.setAddTaskAssignedTo(e.target.value)}
                    >
                        {AppContext.users.map((user, index) => (
                            <option key={index} value={user.Id}>
                                {user.Name}
                            </option>
                        ))}
                    </select>


                    <div style={{ width: "100%", display: "flex", flexDirection: "row", marginTop: "10px" }}>
                        <label>
                            <input
                                type="checkbox"
                                checked={AppContext.notifyUser}
                                onChange={() => AppContext.setNotifyUser(!AppContext.notifyUser)} /> Notify user by email
                        </label>
                    </div>


                </div>
                <div style={{ width: "33%" }}>
                    Start Date
                    <br />
                    <DatePicker
                        className={`datepicker-field add-task-field-date-start ${AppContext.errorAddTaskStartDate ? "form-field-error" : null
                            }`}
                        dateFormat="yyyy-MM-dd"
                        selected={AppContext.addTaskStartDate}
                        onChange={(date) => {
                            AppContext.setAddTaskStartDate(date);
                        }}
                        popperPlacement={datePopperConfig.placement}
                        popperModifiers={datePopperConfig.modifiers}

                    />
                    {AppContext.errorAddTaskStartDate && (
                        <div style={{width: "100%"}}>
                            <span className="form-field-error-message">
                                This field is necessary
                            </span>
                        </div>
                    )}
                </div>
                <div style={{ width: "33%" }}>
                    Due Date
                    <br />
                    <DatePicker
                        className={`datepicker-field add-task-field-date-due ${AppContext.errorAddTaskEndDate ? "form-field-error" : null
                            }`}
                        dateFormat="yyyy-MM-dd"
                        selected={AppContext.addTaskEndDate}
                        onChange={(date) => AppContext.setAddTaskEndDate(date)}
                        popperPlacement={datePopperConfig.placement}
                        popperModifiers={datePopperConfig.modifiers}
                    />
                    {AppContext.errorAddTaskEndDate && (
                        <div style={{ width: "100%" }}>
                            <span className="form-field-error-message">
                                This field is necessary
                            </span>
                        </div>
                    )}
                </div>
            </div>

            

            <div style={{ marginTop: "20px", width: "100%", display: "flex", flexDirection: "row" }}>
                <div style={{ width: "33%" }}>
                    Does this task repeat? <i className="fas fa-info-circle g-ml-5 cursor-helper" style={{ color: "#999" }} title="This feature will automatically create separate tasks that repeat periodically until the selected end date"></i>
                    <br />
                    <select onChange={(e) => AppContext.setAddTaskRecurrency(e.target.value)} value={AppContext.addTaskRecurrency}>
                        {AppContext.recurrences.map((item, index) => (
                            <option key={index} value={item.id}>{item.name}</option>
                        ))}
                    </select>
                </div>
                <div style={{ width: "33%" }}>
                    {AppContext.addTaskRecurrency != 0 && <>
                        When should it stop repeating?
                        <br />
                        <DatePicker
                            className={`datepicker-field ${AppContext.errorAddTaskRecurrencyEndDate ? "form-field-error" : null
                                }`}
                            dateFormat="yyyy-MM-dd"
                            selected={AppContext.addTaskRecurrencyEndDate}
                            onChange={(date) => AppContext.setAddTaskRecurrencyEndDate(date)}
                            popperPlacement={datePopperConfig.placement}
                            popperModifiers={datePopperConfig.modifiers}
                        />
                        {AppContext.errorAddTaskRecurrencyEndDate && (
                            <div style={{ width: "100%" }}>
                                <span className="form-field-error-message">
                                    This field is necessary
                                </span>
                            </div>
                        )}
                    </>}
                </div>
                
            </div>
            <br />
            <div style={{ textAlign: "center", display: "flex", flexDirection: "row", width:"100%"} }>
                <div
                    onClick={() => setIsEntityAssociationExpanded(!isEntityAssociationExpanded)}
                    style={{ padding: '10px 16px', width: "100%", fontWeight: 500, color: '#333', backgroundColor: '#fff',  marginBottom: "30px", border: '1px solid #dcdcdc', borderRadius: '6px', cursor: 'pointer'}}
                >
                    <i
                        className={isEntityAssociationExpanded ? "fas fa-angle-up" : "fas fa-angle-down"}
                        style={{ fontSize: '16px' }}
                    ></i>
                    <span style={{ marginLeft: '20px' }}>Linked Items</span>
                </div>

            </div>
            {isEntityAssociationExpanded && <EntityAssociation context={TaskManagerAppContext} />}

            <br />


            <div className="action-button-bar">
                <div className="action-button-bar-left">
                    {AppContext.isAddingTask ? (
                        <LoadingSpinnerImage />
                    ) : (
                        <button
                            className="action-button save-button"
                            onClick={AppContext.addTask}
                        >
                            Add task
                        </button>
                    )}
                </div>
                <div className="action-button-bar-center">
                    
                </div>
                <div className="action-button-bar-right">
                    <button
                        className="action-button cancel-button"
                        onClick={() => AppContext.showAddTaskPopup(false)}
                    >
                        Cancel
                    </button>
                </div>
            </div>



            
        </div>

        </div>
    );
};

/* 
  This draws the task details side pane
*/

const TaskDetailsPane = () => {
    const AppContext = useContext(TaskManagerAppContext);

    const [showItemContextMenu, setShowItemContextMenu] = useState(false);

    const currentTaskNameRef = useRef(null);
    const contextMenuButton = useRef(null);
    const contextMenu = useRef(null);

    

    const displayDescription = (text) => {
        if (!text)
            text = "";
        text = text.replace(/</g, '&lt;');
        text = text.replace(/\n/g, '<br/>');
        return text;
    };





    const openContextualMenu = () => {
        setShowItemContextMenu(!showItemContextMenu);
    };

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (
                contextMenuButton.current &&
                !contextMenuButton.current.contains(e.target) &&
                contextMenu.current &&
                !contextMenu.current.contains(e.target)
            ) {
                setShowItemContextMenu(false);
                AppContext.setIsShowingDeleteConfirmation(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);


    useEffect(() => {

        if(!AppContext.isPaneOpen)
            setShowItemContextMenu(false);

        AppContext.setChangedAssignee(false);
    }, [AppContext.isPaneOpen])



    return (
        <>
            <div
                style={{ height: "100vh", overflow: "auto" }}
                className={`slide-pane ${AppContext.isPaneOpen ? "open" : ""}`}
            >
                <div className="content">

                    {AppContext.errorLoadingTaskDetails ? <>

                        <div>An error occurred while loading this task...</div>

                    </> : <>

                        <div id="fields-content" style={{ flex: 1, flexDirection: "column", paddingLeft: "10px", height: "92vh", overflowY: "auto", position: "relative", display: "flex" }}>

                            <div id="multiple-contents" style={{ flex: 1, overflow: "auto", paddingRight: "15px" }}>
                            
                                {/* FIELDS AND TABLES */}

                                <div style={{ flex: "1" }}>

                                    {(AppContext.currentTask === null || AppContext.isLoadingTaskDetails) ? (
                                        <>
                                            <LoadingSpinnerImage />
                                        </>
                                    ) : (
                                        <>

                                            <div style={{ display: "flex", marginBottom: "10px" }}>

                                                <div style={{flex: 1, marginRight: "20px"}}>
                                                    <h3>{AppContext.currentTask.Name}</h3>
                                                </div>

                                                <div style={{marginRight: "5px"} }>
                                                    <button ref={contextMenuButton} className="close-button" onClick={openContextualMenu}>
                                                        <i className="fas fa-ellipsis-v"></i>
                                                    </button>
                                                </div>

                                                <div>
                                                    <button className="close-button" onClick={AppContext.closePane}>
                                                        <i className="fas fa-times"></i>
                                                    </button>
                                                </div>
                                                    
                                            </div>







                                            {/* Form field: Name */}
                                            <div className="view-task-field">

                                                <div className="view-task-field-line">

                                                    <div className="view-task-field-title">Name</div>
                                                    <div className="view-task-field-value">

                                                        {AppContext.isEditingField.name === false ? (
                                                            <>
                                                                <span
                                                                    className={`editable-field-span ${AppContext.errorCurrentTaskName
                                                                        ? "form-field-error"
                                                                        : null
                                                                        }`}
                                                                    onClick={(e) => {
                                                                        AppContext.enableTaskFormFieldEdit("name", e);
                                                                        setTimeout(() => {
                                                                            // We need this timeout because the ref for the edit field isn't immediately available
                                                                            currentTaskNameRef.current.selectionStart = 0;
                                                                            currentTaskNameRef.current.selectionEnd = 0;
                                                                        }, 10);
                                                                    }
                                                                    }
                                                                >
                                                                    {AppContext.currentTask.Name}
                                                                    {AppContext.errorCurrentTaskName && (
                                                                        <span className="form-field-error-message">
                                                                            The field Name is necessary
                                                                        </span>
                                                                    )}
                                                                </span>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <span style={{width: "100%"}}>
                                                                    <input
                                                                        ref={currentTaskNameRef}
                                                                        style={{ width: "100%" }}
                                                                        autoFocus
                                                                        onBlur={() => {
                                                                            AppContext.disableAllTaskFormFieldsEdit();
                                                                            AppContext.validFormField(
                                                                                AppContext.currentTask.Name,
                                                                                AppContext.setErrorCurrentTaskName
                                                                            );
                                                                        }}
                                                                        onChange={(e) =>
                                                                            AppContext.setCurrentTask({
                                                                                ...AppContext.currentTask,
                                                                                Name: e.target.value
                                                                            })
                                                                        }
                                                                        value={AppContext.currentTask.Name}
                                                                    />
                                                                </span>
                                                            </>
                                                        )}

                                                    </div>
                                                
                                                </div>
                                            </div>

                                            {/* Form field: Description */}

                                            <div className="view-task-field">

                                                <div className="view-task-field-line">
                                                    <div className="view-task-field-title">Description</div>
                                                    <div className="view-task-field-value">

                                                        {AppContext.isEditingField.description === false ? (
                                                            <>
                                                                <div
                                                                    className={`editable-field-span thin-scrollbar`}
                                                                    style={{ width: "100%", maxHeight: "300px", overflowY: "auto" }}
                                                                    onClick={(e) =>
                                                                        AppContext.enableTaskFormFieldEdit("description", e)
                                                                    }
                                                                >

                                                                    {AppContext.currentTask.Description == "" ?
                                                                        <span style={{ color: "#c0c0c0" }}>Add a description</span>
                                                                        :
                                                                        <div dangerouslySetInnerHTML={{ __html: displayDescription(AppContext.currentTask.Description) }} />
                                                                    }
                                                                </div>

                                                            </>
                                                        ) : (
                                                            <>
                                                                <span style={{ width: "100%" }}>
                                                                    <textarea
                                                                        style={{ width: "100%", height: "150px" }}
                                                                        autoFocus
                                                                        onBlur={() => {
                                                                            AppContext.disableAllTaskFormFieldsEdit();
                                                                        }}
                                                                        onChange={(e) =>
                                                                            AppContext.setCurrentTask({
                                                                                ...AppContext.currentTask,
                                                                                Description: e.target.value
                                                                            })
                                                                        }
                                                                        value={AppContext.currentTask.Description}
                                                                    />
                                                                </span>
                                                                {/*<Trumbowyg data={""} />*/}
                                                            </>
                                                        )}

                                                    </div>
                                                </div>

                                            </div>

                                                    {/* Form field: AssignedTo */}

                                                    <div className="view-task-field">
                                                        <div className="view-task-field-line">
                                                            <div className="view-task-field-title">Assigned to</div>
                                                            <div className="view-task-field-value">
                                                                {AppContext.isEditingField.assignedTo === false ? (
                                                                    <>
                                                                        <div
                                                                            className="editable-field-span"
                                                                            onClick={(e) =>
                                                                                AppContext.enableTaskFormFieldEdit("assignedTo", e)
                                                                            }
                                                                        >
                                                                            {AppContext.currentTask.AssignedTo && AppContext.users.find(u => u.Id == AppContext.currentTask.AssignedTo) ?
                                                                                <>
                                                                                    <User value={AppContext.currentTask.AssignedTo} />
                                                                                </>
                                                                                :
                                                                                <span className="placeholder-text">Add a user</span>
                                                                            }
                                                                        </div>
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <span>
                                                                            <select
                                                                                value={AppContext.currentTask.AssignedTo}
                                                                                onBlur={() =>
                                                                                    AppContext.disableAllTaskFormFieldsEdit()
                                                                                }
                                                                                    onChange={(e) => {
                                                                                        AppContext.setChangedAssignee(true);
                                                                                        AppContext.setCurrentTask({
                                                                                            ...AppContext.currentTask,
                                                                                            AssignedTo: e.target.value
                                                                                        });
                                                                                    }}
                                                                                >
                                                                                    {AppContext.users.map((user, index) => (
                                                                                        <option key={index} value={user.Id}>
                                                                                            {user.Name}
                                                                                        </option>
                                                                                    ))}
                                                                                </select>
                                                                            </span>
                                                                    </>
                                                                )}

                                                                {/* Conditionally show this div when the value differs from the original data */}
                                                                <div
                                                                    style={{
                                                                        width: "100%",
                                                                        display: AppContext.changedAssignee ? "flex" : "none",
                                                                        flexDirection: "row",
                                                                        marginTop: "8px",
                                                                        marginLeft: "10px"
                                                                    }}
                                                                >
                                                                    <label>
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={AppContext.notifyUser}
                                                                            onChange={() => {
                                                                                AppContext.setNotifyUser(!AppContext.notifyUser)
                                                                            }}
                                                                        /> Notify user by email
                                                                    </label>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                            {/* BLOCK WITH TWO COLUMNS */}

                                            <div style={{ display: "flex", flexDirection: "column" }}>

                                                <div style={{ display: "flex", flexDirection: "row" }}>
                                                    <div style={{ width: "50%" }}>
                                                        {/* Form field: Priority */}

                                                        <div className="view-task-field">
                                                            <div className="view-task-field-line">
                                                                <div className="view-task-field-title">Priority</div>
                                                                <div className="view-task-field-value">
                                                                    {AppContext.isEditingField.priority === false ? (
                                                                        <>
                                                                            <span
                                                                                className="editable-field-span editable-field-span-complex"
                                                                                onClick={(e) =>
                                                                                    AppContext.enableTaskFormFieldEdit("priority", e)
                                                                                }
                                                                            >
                                                                                <Priority value={AppContext.currentTask.Priority} />

                                                                            </span>
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <span>
                                                                                <select
                                                                                    value={AppContext.currentTask.Priority}
                                                                                    onBlur={() =>
                                                                                        AppContext.disableAllTaskFormFieldsEdit()
                                                                                    }
                                                                                    onChange={(e) => {
                                                                                        AppContext.setCurrentTask({
                                                                                            ...AppContext.currentTask,
                                                                                            Priority: e.target.value
                                                                                        });
                                                                                    }}
                                                                                >
                                                                                    {AppContext.priorities.map((priority, index) => (
                                                                                        <option key={index} value={priority.id}>
                                                                                            {priority.name}
                                                                                        </option>
                                                                                    ))}
                                                                                </select>
                                                                            </span>
                                                                        </>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div style={{ width: "50%" }}>
                                                        {/* Form field: Created Date */}

                                                        <div className="view-task-field">
                                                            <div className="view-task-field-line">
                                                                <div className="view-task-field-title">Created by</div>
                                                                <div className="view-task-field-value">
                                                                    <span style={{ display: "flex", flexDirection: "row" }}>
                                                                        {
                                                                            <User
                                                                                value={AppContext.currentTask.CreatedBy}
                                                                                size="small"
                                                                            />
                                                                        }
                                                                        <span style={{ marginLeft: "5px" }}>
                                                                            {AppContext.readableDate(AppContext.currentTask.CreatedDate, true)}
                                                                        </span>
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div style={{ display: "flex", flexDirection: "row" }}>
                                                    <div style={{ width: "50%" }}>
                                                        {/* Form field: Board Step */}

                                                        <div className="view-task-field">
                                                            <div className="view-task-field-line">
                                                                <div className="view-task-field-title">Board</div>
                                                                <div className="view-task-field-value">
                                                                    {AppContext.isEditingField.boardStep === false ? (
                                                                        <>
                                                                            <span
                                                                                className="editable-field-span"
                                                                                onClick={(e) =>
                                                                                    AppContext.enableTaskFormFieldEdit("boardStep", e)
                                                                                }
                                                                            >
                                                                                <BoardStep value={AppContext.currentTask.BoardStep} />

                                                                            </span>
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <span>
                                                                                <select
                                                                                    value={AppContext.currentTask.BoardStep}
                                                                                    onBlur={() =>
                                                                                        AppContext.disableAllTaskFormFieldsEdit()
                                                                                    }
                                                                                    onChange={(e) => {
                                                                                        AppContext.setCurrentTask({
                                                                                            ...AppContext.currentTask,
                                                                                            BoardStep: e.target.value
                                                                                        });
                                                                                    }}
                                                                                >
                                                                                    {AppContext.boards[0].Steps.sort(
                                                                                        (a, b) => a.BoardStepOrder - b.BoardStepOrder
                                                                                    ).map((step, index) => (
                                                                                        <>
                                                                                            {(index == 0) ? <option value="null">None</option> : null}
                                                                                            <option value={step.BoardStepId}>
                                                                                                {step.BoardStepName}
                                                                                            </option>
                                                                                        </>
                                                                                    ))}
                                                                                </select>
                                                                            </span>
                                                                        </>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div style={{ width: "50%" }}>
                                                        {/* Form field: Start Date */}

                                                        <div className="view-task-field">
                                                            <div className="view-task-field-line">
                                                                <div className="view-task-field-title">Start date</div>
                                                                <div className="view-task-field-value">
                                                                    {AppContext.isEditingField.startDate === false ? (
                                                                        <>
                                                                            <span
                                                                                className="editable-field-span"
                                                                                onClick={(e) =>
                                                                                    AppContext.enableTaskFormFieldEdit("startDate", e)
                                                                                }
                                                                            >
                                                                                {AppContext.readableDate(AppContext.currentTask.StartDate, true)}
                                                                            </span>
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <span>
                                                                                <DatePicker
                                                                                    dateFormat="yyyy-MM-dd"
                                                                                    onBlur={() =>
                                                                                        AppContext.disableAllTaskFormFieldsEdit()
                                                                                    }
                                                                                    selected={AppContext.unformatDate(
                                                                                        AppContext.currentTask.StartDate
                                                                                    )}
                                                                                    onChange={(date) => {
                                                                                        let newObj = {
                                                                                            ...AppContext.currentTask,
                                                                                            StartDate: AppContext.formatDate(date)
                                                                                        };
                                                                                        AppContext.setCurrentTask(newObj);
                                                                                        AppContext.disableAllTaskFormFieldsEdit();
                                                                                    }}
                                                                                    popperPlacement={datePopperConfig.placement}
                                                                                    popperModifiers={datePopperConfig.modifiers}
                                                                                />
                                                                            </span>
                                                                        </>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div style={{ display: "flex", flexDirection: "row" }}>
                                                    <div style={{ width: "50%" }}>
                                                        {/* Form field: Due Date */}

                                                        <div className="view-task-field">
                                                            <div className="view-task-field-line">
                                                                <div className="view-task-field-title">Due date</div>
                                                                <div className="view-task-field-value">
                                                                    {AppContext.isEditingField.dueDate === false ? (
                                                                        <>
                                                                            <span
                                                                                className="editable-field-span"
                                                                                onClick={(e) =>
                                                                                    AppContext.enableTaskFormFieldEdit("dueDate", e)
                                                                                }
                                                                            >
                                                                                <DueDate date={AppContext.currentTask.DueDate} showYear="true" />
                                                                            </span>
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <span>
                                                                                <DatePicker
                                                                                    dateFormat="yyyy-MM-dd"
                                                                                    onBlur={() =>
                                                                                        AppContext.disableAllTaskFormFieldsEdit()
                                                                                    }
                                                                                    selected={AppContext.unformatDate(
                                                                                        AppContext.currentTask.DueDate
                                                                                    )}
                                                                                    onChange={(date) => {
                                                                                        let newObj = {
                                                                                            ...AppContext.currentTask,
                                                                                            DueDate: AppContext.formatDate(date)
                                                                                        };
                                                                                        AppContext.setCurrentTask(newObj);
                                                                                        AppContext.disableAllTaskFormFieldsEdit();
                                                                                    }}
                                                                                    popperPlacement={datePopperConfig.placement}
                                                                                    popperModifiers={datePopperConfig.modifiers}
                                                                                />
                                                                            </span>
                                                                        </>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div style={{ width: "50%" }}>
                                                        {/* Form field: Estimated Time */}

                                                        <div className="view-task-field">
                                                            <div className="view-task-field-line">
                                                                <div className="view-task-field-title">Estimated time (h)</div>
                                                                <div className="view-task-field-value">
                                                                    {AppContext.isEditingField.estimatedTime === false ? (
                                                                        <>
                                                                            <span
                                                                                className="editable-field-span"
                                                                                onClick={(e) =>
                                                                                    AppContext.enableTaskFormFieldEdit(
                                                                                        "estimatedTime",
                                                                                        e
                                                                                    )
                                                                                }
                                                                            >
                                                                                {AppContext.currentTask.EstimatedTime}h
                                                                            </span>
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <span>
                                                                                <input
                                                                                    style={{ width: "50px" }}
                                                                                    autoFocus
                                                                                    onBlur={() =>
                                                                                        AppContext.disableAllTaskFormFieldsEdit()
                                                                                    }
                                                                                    onChange={(e) =>
                                                                                        AppContext.setCurrentTask({
                                                                                            ...AppContext.currentTask,
                                                                                            EstimatedTime: e.target.value
                                                                                        })
                                                                                    }
                                                                                    value={AppContext.currentTask.EstimatedTime}
                                                                                /> h
                                                                            </span>
                                                                        </>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div style={{ display: "flex", flexDirection: "row" }}>
                                                    <div style={{ width: "50%" }}>
                                                        {/* Form field: Completeness */}

                                                        <div className="view-task-field">
                                                            <div className="view-task-field-line">
                                                                <div className="view-task-field-title">Completed Status</div>
                                                                <div className="view-task-field-value">
                                                                            {AppContext.isEditingField.completed === false ? (
                                                                                <>
                                                                                    <span
                                                                                        className="editable-field-span"
                                                                                        style={AppContext.currentTask.CompletionStatus == "0" && AppContext.currentTask.SubtaskCount > 0 ? { cursor: "not-allowed" } : {}}
                                                                                        onClick={async (e) => {
                                                                                            if (AppContext.currentTask.CompletionStatus == "0" && AppContext.currentTask.SubtaskCount > 0) {
                                                                                                let hasIncomplete = await AppContext.checkHasIncompleteSubtasks(AppContext.currentTask.Id);
                                                                                                if (hasIncomplete) {
                                                                                                    alert("Cannot modify completion status. It contains incomplete subtasks.");
                                                                                                    return;
                                                                                                }
                                                                                            }

                                                                                            AppContext.enableTaskFormFieldEdit("completed", e);
                                                                                        }}
                                                                                    >
                                                                                        <CompletionStatus value={AppContext.getCompletenessById(AppContext.currentTask.CompletionStatus)?.name} forTaskDetails="true" />
                                                                                    </span>
                                                                                </>
                                                                            ) : (
                                                                                <>
                                                                                    <span>
                                                                                        <select
                                                                                            value={AppContext.currentTask.CompletionStatus}
                                                                                            onBlur={() =>
                                                                                                AppContext.disableAllTaskFormFieldsEdit()
                                                                                            }
                                                                                            onChange={async (e) => {
                                                                                                let selectedVal = e.target.value;

                                                                                                if (selectedVal == "1" && AppContext.currentTask.SubtaskCount > 0) {
                                                                                                    let hasIncomplete = await AppContext.checkHasIncompleteSubtasks(AppContext.currentTask.Id);
                                                                                                    if (hasIncomplete) {
                                                                                                        alert("Cannot mark this task as completed because it contains incomplete subtasks.");
                                                                                                        return;
                                                                                                    }
                                                                                                }

                                                                                                AppContext.setCurrentTask({
                                                                                                    ...AppContext.currentTask,
                                                                                                    CompletionStatus: selectedVal
                                                                                                });
                                                                                            }}
                                                                                        >
                                                                                            {AppContext.completeness.map((complete, index) => (
                                                                                                <option key={index} value={complete.id}>
                                                                                                    {complete.name}
                                                                                                </option>
                                                                                            ))}
                                                                                        </select>
                                                                                    </span>
                                                                                </>
                                                                            )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div style={{ width: "50%" }}>

                                                        {/* Form field: Follow */}

                                                        <div className="view-task-field">
                                                            <div className="view-task-field-line">
                                                                        <div className="view-task-field-title">Follow completion</div>
                                                                        <div className="view-task-field-value">
                                                                            {AppContext.currentTask.Followers ? <>

                                                                                {AppContext.currentTask.Followers.map((userId, index) =>
                                                                                    <span key={index} style={{ marginLeft: "5px" }}>
                                                                                        <User value={userId} size="small" />
                                                                                    </span>
                                                                                )}

                                                                                {AppContext.isProcessingFollow ? <>
                                                                                    <LoadingSpinnerImage small={true} />
                                                                                </> : <>

                                                                                        {AppContext.currentTask.Followers.includes(AppContext.currentUserId) ? <>
                                                                                            <span className="follow-button unfollow" onClick={() => AppContext.followTask(AppContext.currentTask.Id, false)}>
                                                                                                Disable notification</span>
                                                                                        </> : <>
                                                                                            <span className="follow-button" title="Get notified by email when the task is marked as completed"
                                                                                                    onClick={() => AppContext.followTask(AppContext.currentTask.Id, true)}>
                                                                                                    <i className="fas fa-bell" style={{marginRight: "8px"}}></i>Get notified when completed</span>
                                                                                    </>}
                                                                                </>}

                                                                    </> : null}
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>


                                            {/* SHOW MORE/LESS */}

                                            <div className="task-details-see-more-separator">
                                                <div className="side">
                                                    <hr />
                                                </div>
                                            </div>



                                            <div
                                                style={{
                                                    display: "flex",
                                                    width: "100%",
                                                    flexDirection: "row",
                                                    marginBottom: "15px"
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        cursor: "pointer",
                                                        paddingBottom: "3px",
                                                        paddingRight: "10px",
                                                        ...(AppContext.visibleTaskDetailsTab == "entities"
                                                            ? { borderBottom: "2px solid #00abff" }
                                                            : { borderBottom: "2px solid #f0f0f0" })
                                                    }}
                                                    onClick={() => AppContext.setVisibleTaskDetailsTab("entities")}
                                                >
                                                    <i className="fas fa-project-diagram g-mr-5"></i> Linked To
                                                </div>

                                    <div
                                        style={{
                                            cursor: "pointer",
                                            paddingRight: "10px",
                                            paddingLeft: "5px",
                                            ...(AppContext.visibleTaskDetailsTab == "comments"
                                                ? { borderBottom: "2px solid #00abff" }
                                                : { borderBottom: "2px solid #f0f0f0" })
                                        }}
                                        onClick={() => AppContext.setVisibleTaskDetailsTab("comments")}
                                    >
                                        <i className="fas fa-comments g-mr-5"></i> Comments
                                    </div>
                                    
                                    <div
                                        style={{
                                            cursor: "pointer",
                                            paddingRight: "10px",
                                            paddingLeft: "5px",
                                            ...(AppContext.visibleTaskDetailsTab == "subtasks"
                                                ? { borderBottom: "2px solid #00abff" }
                                                : { borderBottom: "2px solid #f0f0f0" })
                                        }}
                                        onClick={() => AppContext.setVisibleTaskDetailsTab("subtasks")}
                                    >
                                        <img style={{ width: "10px", marginRight: "8px" }} src="/assets/images/subtask_icon.png" />Sub Tasks
                                    </div>


                                    
                                    <div
                                        style={{
                                            cursor: "pointer",
                                            paddingRight: "10px",
                                            paddingLeft: "5px",
                                            ...(AppContext.visibleTaskDetailsTab == "attachments"
                                                ? { borderBottom: "2px solid #00abff" }
                                                : { borderBottom: "2px solid #f0f0f0" })
                                        }}
                                        onClick={() => AppContext.setVisibleTaskDetailsTab("attachments")}
                                    >
                                        <i className="fas fa-paperclip g-mr-5"></i> Attachments
                                    </div>



                                    <div
                                        style={{
                                            cursor: "pointer",
                                            paddingRight: "10px",
                                            paddingLeft: "5px",
                                            ...(AppContext.visibleTaskDetailsTab == "moreoptions"
                                                ? { borderBottom: "2px solid #00abff" }
                                                : { borderBottom: "2px solid #f0f0f0" })
                                        }}
                                        onClick={() => AppContext.setVisibleTaskDetailsTab("moreoptions")}
                                    >
                                        <i className="fas fa-cog g-mr-5"></i> More options
                                    </div>


                                                <div style={{ flex: 1, borderBottom: "2px solid #f0f0f0" }}></div>
                                            </div>


                                            {AppContext.visibleTaskDetailsTab == "entities" && <>

                                                {/* ENTITY ASSOCIATIONS */}
                                                <EntityAssociation context={TaskManagerAppContext} />

                                            </>}


                                            {AppContext.visibleTaskDetailsTab == "comments" && <>

                                                {/* COMMENTS */}
                                                {(AppContext.currentTask === null || AppContext.isLoadingTaskDetails) ? (
                                                    <>
                                                    </>
                                                ) : (
                                                    <>
                                                        <div style={{ marginBottom: "20px" }}>
                                                            <TaskCommentList taskId={AppContext.currentTask.Id} />
                                                        </div>
                                                    </>
                                                )}

                                            </>}


                                            {AppContext.visibleTaskDetailsTab == "subtasks" && <>

                                                {/* SUBTASKS */}
                                                {(AppContext.currentTask === null || AppContext.isLoadingTaskDetails) ? (
                                                    <>
                                                    </>
                                                ) : (
                                                    <>
                                                        <div style={{ marginBottom: "20px" }}>
                                                            <SubTasks parentTaskId={AppContext.currentTask.Id} />
                                                        </div>
                                                    </>
                                                )}

                                            </>}



                                
                                {AppContext.visibleTaskDetailsTab == "attachments" && <>

                                    {/* ATTACHMENTS */}
                                    {(AppContext.currentTask === null || AppContext.isLoadingTaskDetails) ? (
                                        <>
                                        </>
                                    ) : (
                                        <>
                                                                    <div style={{ marginBottom: "20px" }}>
                                                                        <Attachments EntityType="task-manager" EntityId={AppContext.currentTask.Id} users={AppContext.users} userRole="Admin" />
                                            </div>
                                        </>
                                    )}

                                </>}




                                {AppContext.visibleTaskDetailsTab == "moreoptions" && <>

                                                {/* MORE OPTIONS */}
                                                {(AppContext.currentTask === null || AppContext.isLoadingTaskDetails) ? (
                                                    <>
                                                    </>
                                                ) : (
                                                    <>
                                                        <div style={{ marginBottom: "20px" }}>
                                                            <DuplicateTask taskId={AppContext.currentTask.Id} />
                                                        </div>
                                                    </>
                                                )}

                                            </>}
                            



                                        </>
                                    )}

                                </div>

                            </div>



                            <div id="buttom-bar" style={{ borderTop: "1px solid #f0f0f0" }}>

                                {/* BOTTOM BUTTONS */}

                                {(AppContext.currentTask === null || AppContext.isLoadingTaskDetails) ? (
                                    <>
                                    </>
                                ) : (

                                <>
                                    {/*
                                    <div>
                                        <label>
                                            <input
                                                type="checkbox"
                                                checked={AppContext.notifyUser}
                                                onChange={() => AppContext.setNotifyUser(!AppContext.notifyUser)} /> Notify assigned user of changes
                                        </label>
                                    </div>
                                    */}

                                    <div className="action-button-bar">
                                        <div className="action-button-bar-left">
                                                        <button
                                                            className="action-button cancel-button"
                                                            onClick={AppContext.closePane}
                                                        >
                                                            Cancel
                                                        </button>

                                            </div>
                                            <div className="action-button-bar-center">
                                                            <span
                                                                className={`${AppContext.isShowingSaveMessage
                                                                    ? "save-message-shown"
                                                                    : "save-message-hidden"
                                                                    }`}
                                                                onTransitionEnd={() => AppContext.setIsShowingSaveMessage(false)}
                                                            >
                                                                Save successful!
                                                            </span>
                                            </div>

                                            <div className="action-button-bar-right">
                                                            {!AppContext.isSavingTask ? (
                                                                <>
                                                                    <button
                                                                        className="action-button save-button"
                                                                        onClick={AppContext.saveCurrentTask}
                                                                    >
                                                                        Save
                                                                    </button>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <LoadingSpinnerImage />
                                                                </>
                                                            )}
                                                            

                                                        </div>
                                                

                                            </div>
                                    </>
                            
                                )}


                            </div>



                        </div>



                    </>}



          

                </div>
            </div>


            {/* CONTEXT MENU */}

            {showItemContextMenu && (
                <div
                    ref={contextMenu}
                    style={{
                        position: "fixed",
                        top: `50px`,
                        right: `70px`,
                        background: "white",
                        border: "1px solid #ccc",
                        padding: "4px",
                        borderRadius: "10px",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                        zIndex: 1000,
                        borderRadius: "15px",

                    }}
                >

                    {/* DELETE */}

                    {!AppContext.isShowingDeleteConfirmation ? <>
                        <div className="context-menu-option" onClick={() => AppContext.setIsShowingDeleteConfirmation(true)}><i className="far fa-trash-alt"></i> Delete this task</div>
                    </> : <>
                        {AppContext.isDeletingTask ?
                            <LoadingSpinnerImage />
                            : 
                            <div className="context-menu-option context-delete-option" onClick={AppContext.deleteCurrentTask}><i className="far fa-trash-alt"></i> Confirm delete?</div>
                        }
                    </>}


                </div>
            )}
        </>
    );
};






/* 
 * This method is responsible for loading the subtasks for the PANE VIEW ONLY (task details pane) 
 * The subtasks for the main list are loaded with the traditional loadTasks method
 */


const SubTasks = ({ parentTaskId }) => {

    const AppContext = useContext(TaskManagerAppContext);

    useEffect(() => {

        let alreadyLoadedSubTasks = AppContext.alreadyLoadedSubTasks;
        let currentSubTasksList = AppContext.currentSubTasksList;

        // Is it a force reload? (probably after creating a new subtask)
        if (AppContext.reloadSubTasks) {
            currentSubTasksList = [];
            alreadyLoadedSubTasks = false;

            AppContext.setCurrentSubTasksList(currentSubTasksList);
            AppContext.setAlreadyLoadedSubTasks(alreadyLoadedSubTasks);
            AppContext.setReloadSubTasks(false);
        }

        if (currentSubTasksList.length == 0) {

            if (AppContext.isLoadingPaneSubTasks || alreadyLoadedSubTasks) return;

            AppContext.setIsLoadingPaneSubTasks(true);

            let localEntityType = "";
            let localEntityId = "";
            let localSearch = "";
            let localSortBy = AppContext.defaultTaskListSortByField;
            let localSortType = AppContext.defaultTaskListSortByType;
            let localShowAssignedTo = "Company"; // Always show all subtasks
            let localPage = 1;
            let localCompletionStatus = "All";
        

            let loadObjectsURL =
            `/umbraco/api/TaskManagerApi/Tasks?` +
            `entityType=${encodeURIComponent(localEntityType)}&` +
            `entityId=${encodeURIComponent(localEntityId)}&` +
            `search=${encodeURIComponent(localSearch)}&` +
            `sortBy=${encodeURIComponent(localSortBy)}&` +
            `sortType=${encodeURIComponent(localSortType)}&` +
            `assignedTo=${encodeURIComponent(localShowAssignedTo)}&` +
            `page=${encodeURIComponent(localPage)}&` +
            `completionStatus=${encodeURIComponent(localCompletionStatus)}&` +
            `parentTaskId=${encodeURIComponent(parentTaskId)}&`;

            
            let requestOptions = {};

            fetch(loadObjectsURL, requestOptions)
                .then((response) => {
                    if (!response.ok) {
                        if (response.status === 401)
                            document.dispatchEvent(new Event("api:unauthorized"));

                        AppContext.setAlreadyLoadedSubTasks(true);
                        throw new Error("Network response was not ok");
                    }
                    return response.json();
                })
                .then((data) => {

                    if (data.length > 0) {
                        AppContext.setCurrentSubTasksList(data);
                    }

                })
                .catch((error) => {
                    // Handle any errors that occurred during the fetch
                })
                .finally(() => {
                    AppContext.setIsLoadingPaneSubTasks(false);
                    AppContext.setAlreadyLoadedSubTasks(true);
                });
            

        }
        

    }, [AppContext.reloadSubTasks]);

    return (<>

        {AppContext.isLoadingPaneSubTasks ? <>

            <div><LoadingSpinnerImage /></div>

        </> : <>


            <div className="action-button-bar">
                <div className="action-button-bar-left g-mb-20">
                    <button onClick={() => { AppContext.setAddTaskParentTaskId(parentTaskId); AppContext.showAddTaskPopup(true, true); }} className="action-button save-button">Add a subtask</button>
                </div>
            </div>


            <div className="thin-scrollbar" style={{ overflow: "auto" }}>

                <table className="taskManagerTable results-table">

                    <thead>
                        <tr>
                            <th style={{ width: "25px", }}>
                                <span className="table-column-filter"></span>
                            </th>
                            <th style={AppContext.hasLimitedWidth ? {width: "auto"} : { width: "78%" }}>
                                <span className="table-column-filter">SUBTASK NAME</span>
                            </th>
                            <th style={{ width: "10%", }}>
                                <span className="table-column-filter">ASSIGNED TO</span>
                            </th>
                            <th style={{ width: "12%", }}>
                                <span className="table-column-filter">DUE DATE</span>
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        {AppContext.currentSubTasksList.map((item, index) => {

                            return (
                                <tr className="results-table-row" key={index}>
                                    <td style={{ width: "25px" }}>
                                        <CompletionStatus value={AppContext.getCompletenessById(item.CompletionStatus)?.name} onlyIcon="true" />
                                    </td>
                                    <td style={{ width: "78%", cursor: "pointer" }} onClick={(e) => AppContext.loadTaskDetails(item.Id, e)}>
                                        <div title={item.Name} className="ellipsis">
                                            {item.Name}
                                        </div>
                                    </td>
                                    <td style={{ width: "10%" }}>
                                        <User value={item.AssignedTo} />
                                    </td>
                                    <td style={{ width: "12%" }}><DueDate date={item.DueDate} showYear="true" /></td>
                                </tr>
                            )
                        }
                        )}
                    </tbody>
                </table>

            </div>


            {AppContext.currentSubTasksList.length == 0 &&
                <div className="no-more-results">No subtasks</div>
            }

        </>}


    </>);

};





const DuplicateTask = ({ taskId }) => {

    const AppContext = useContext(TaskManagerAppContext);

    const [isDuplicating, setIsDuplicating] = useState(false);
    const [duplicateSuccess, setDuplicateSuccess] = useState(false);
    const [duplicateError, setDuplicateError] = useState(false);



    const handleDuplicate = () => {

        setIsDuplicating(true);
        setDuplicateSuccess(false);
        setDuplicateError(false);


        let duplicateURL =
            `/umbraco/api/TaskManagerApi/DuplicateTask?` +
            `taskId=${encodeURIComponent(taskId)}&`;

        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
        };

        fetch(duplicateURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    setDuplicateError(true);
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {

                if (data) {
                    setDuplicateSuccess(true);
                    let newTaskList = [data, ...AppContext.tasks];
                    AppContext.setTasks(newTaskList);
                }

            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
            })
            .finally(() => {
                setIsDuplicating(false);
            });

    }

    return (<>


        {isDuplicating ? 
            <LoadingSpinnerImage />
            :
            <button className="action-button save-button" onClick={handleDuplicate}>Duplicate this task</button>
        }

        {duplicateSuccess ? <span className="duplicate-message-success">This task was duplicated succesfully!</span> : null }
        {duplicateError ? <span className="duplicate-message-error">An unexpected problem ocurred while duplicating this task</span> : null }

        <div style={{ color: "#888", marginTop: "25px", width: "100%", fontSize: "9pt" }} >* Duplicating this task will create a new one with the same main fields, Linked To and Sub Tasks</div>

    </>);

};





const TaskCommentList = ({ taskId }) => {

    const AppContext = useContext(TaskManagerAppContext);

    const [addTaskCommentText, setAddTaskCommentText] = useState("");
    const [isLoadingObjects, setIsLoadingObjects] = useState(false);
    const [itemsPerPage, setItemsPerPage] = useState(2);
    const [errorAddTaskCommentText, setErrorAddTaskCommentText] = useState(null);
    const [isAddingTaskComment, setIsAddingTaskComment] = useState(false);
    const [errorAddingTaskComment, setErrorAddingTaskComment] = useState(false);
    const [editedComment, setEditedComment] = useState(null);
    const useDummy = false;

    const validFormField = (field, errorFunc) => {
        if (field == "") {
            errorFunc(true);
            return false;
        }
        errorFunc(false);
        return true;
    };

    const saveComment = () => {
        console.log("comment for taskID " + taskId + ": " + addTaskCommentText);

        let addTaskCommentURL = "/umbraco/api/TaskManagerApi/Comment/";

        let newTaskComment = {
            Text: addTaskCommentText,
            TaskId: taskId,
        };

        let method = "POST";

        if (editedComment != null) {
            newTaskComment["Id"] = editedComment.Id;
            method = "PUT";
        }

        const requestOptions = {
            method: method,
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(newTaskComment)
        };

        let isValidForm = true;

        setErrorAddTaskCommentText(false);
        setErrorAddingTaskComment(false);

        if (!validFormField(addTaskCommentText, setErrorAddTaskCommentText)) isValidForm = false;

        if (!isValidForm) return false;

        setIsAddingTaskComment(true);

        fetch(addTaskCommentURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
                if (data.Id) {
                    // Do not format data.CreatedDate here; let TaskComment format it on render
                    let newTaskCommentList = [data, ...AppContext.comments];
                    AppContext.setComments(newTaskCommentList);
                    setAddTaskCommentText("");
                    setErrorAddingTaskComment(false);
                } else {
                    console.log("error: ", data);
                    setErrorAddingTaskComment(true);
                }
            })
            .catch((error) => {
                console.log("error: " + error);
                setErrorAddingTaskComment(true);
            })
            .finally(() => {
                setIsAddingTaskComment(false);
            });
    };

    const deleteComment = (taskCommentId) => {
        let deleteTaskCommentURL =
            `/umbraco/api/TaskManagerApi/Comment?` +
            `commentId=${encodeURIComponent(taskCommentId)}&`;

        let method = "DELETE";

        const requestOptions = {
            method: method,
            headers: { "Content-Type": "application/json" },
        };

        fetch(deleteTaskCommentURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
                if (data) {
                    let newTaskCommentList = AppContext.comments.filter((item) => item.Id != taskCommentId);
                    AppContext.setComments(newTaskCommentList);
                }
            })
            .catch((error) => {
                console.log("error: " + error);
            });
    };

    const editComment = (taskCommentId) => {
        let comment = AppContext.comments.find((item) => item.Id == taskCommentId);

        if (comment) {
            setEditedComment(comment);
            setAddTaskCommentText(comment.Text);
        } else {
            console.log(`Comment ${taskCommentId} not found`);
        }
    };

    /* SCROLLING BEHAVIOUR */

    const ref = useRef();
    const isVisible = useIsVisible(ref);

    function useIsVisible(ref) {
        const [isIntersecting, setIntersecting] = useState(false);

        useEffect(() => {
            const observer = new IntersectionObserver(([entry]) =>
                setIntersecting(entry.isIntersecting),
            );

            observer.observe(ref.current);
            return () => {
                observer.disconnect();
            };
        }, [ref]);

        return isIntersecting;
    }

    useEffect(() => {
        if (isVisible && AppContext.taskHasMoreComments && !isLoadingObjects) {
            loadObjects({ nextPage: true });
        }
    }, [isVisible]);

    const loadObjects = ({ nextPage = false } = {}) => {
        if (isLoadingObjects) return;
        if (!AppContext.taskHasMoreComments) return;

        setIsLoadingObjects(true);

        let local_objects = AppContext.comments;
        let local_objects_page = AppContext.commentsPage;

        if (nextPage == false) {
            local_objects = [];
            local_objects_page = 0;
            AppContext.setComments(local_objects);
            AppContext.setCommentsPage(local_objects_page);
            AppContext.setTaskHasMoreComments(true);
        } else {
            local_objects_page++;
            AppContext.setCommentsPage(local_objects_page);
        }

        let loadObjectsURL =
            `/umbraco/api/TaskManagerApi/Comment?` +
            `taskId=${taskId}&` +
            `page=${encodeURIComponent(local_objects_page)}&`;

        fetch(loadObjectsURL)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    AppContext.setTaskHasMoreComments(false);
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
                if (data.length > 0) {
                    if (nextPage) {
                        let res = [...local_objects, ...data];
                        AppContext.setComments(res);
                    } else {
                        AppContext.setComments(data);
                    }
                } else {
                    AppContext.setTaskHasMoreComments(false);
                }
            })
            .catch(() => {
                AppContext.setTaskHasMoreComments(false);
            })
            .finally(() => {
                setIsLoadingObjects(false);
            });
    };

    return (
        <>
            <div style={{ display: "flex", flexDirection: "column" }}>
                <div style={{ display: "flex", flexDirection: "row" }}>
                    <div><User value={AppContext.currentUserId} /> {editedComment != null && editedComment.Edited == 1 ? "(edited)" : null}</div>
                    <div style={{ display: "flex", flexDirection: "column", flex: 1, width: "100%", marginLeft: "10px" }}>
                        {editedComment != null ? (
                            <div style={{ fontSize: "0.8em", color: "#999" }}>
                                Editing comment: "<span style={{ fontStyle: "italic" }}>{AppContext.comments.find((item) => item.Id == editedComment.Id)?.Text.substring(0, 100)}...</span>"
                            </div>
                        ) : null}

                        <textarea
                            className={`addCommentTextBox form-field-text ${errorAddTaskCommentText ? "form-field-error" : ""}`}
                            onChange={(e) => setAddTaskCommentText(e.target.value)}
                            placeholder="Add a comment"
                            value={addTaskCommentText}
                        ></textarea>

                        {errorAddTaskCommentText && (
                            <span className="form-field-error-message">
                                The field Comment is necessary
                            </span>
                        )}

                        <div style={{ display: "flex", flexDirection: "row", alignItems: "center", marginTop: "10px" }}>
                            {isAddingTaskComment ? (
                                <div><LoadingSpinnerImage /></div>
                            ) : (
                                <>
                                    <div>
                                        <button onClick={saveComment} className="action-button save-button">Save comment</button>
                                    </div>
                                    {errorAddingTaskComment && <div>An error occurred...</div>}
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <div style={{ marginTop: "20px", marginBottom: "20px" }}></div>

            <div className="thin-scrollbar" style={{ maxHeight: "100vh", overflow: "auto", paddingRight: "10px" }}>
                {AppContext.comments.length > 0 && (
                    AppContext.comments.map((comment) => (
                        <TaskComment
                            key={comment.Id}
                            comment={comment}
                            deleteCommentFunc={deleteComment}
                            editCommentFunc={editComment}
                        />
                    ))
                )}

                {isLoadingObjects ? (
                    <div style={{ textAlign: "center" }}><LoadingSpinnerImage /></div>
                ) : (
                    !AppContext.taskHasMoreComments && (
                        <div className="no-more-results">
                            {AppContext.comments.length > 0 ? "No more comments" : "No comments"}
                        </div>
                    )
                )}

                <div ref={ref}></div>
            </div>

            <div style={{ minHeight: "20px" }}></div>
        </>
    );
};

const TaskComment = ({ comment, deleteCommentFunc, editCommentFunc }) => {
    const AppContext = useContext(TaskManagerAppContext);

    const [isShowingDeleteCommentButton, setIsShowingDeleteCommentButton] = useState(false);
    const [isShowingOptions, setIsShowingOptions] = useState(false);
    const [isDeletingComment, setIsDeletingComment] = useState(false);

    const showOptions = (status) => {
        setIsShowingDeleteCommentButton(false);
        setIsShowingOptions(status);
        setIsDeletingComment(false);
    };



    function formatDate(iso) {
        if (!iso) return "";

        let str = String(iso).trim();

        // Append 'Z' if missing so JS treats the timestamp as UTC
        if (!str.endsWith("Z") && !str.endsWith("z")) {
            str += "Z";
        }

        const date = new Date(str);
        if (isNaN(date.getTime())) return iso;

        // Passing `undefined` uses the browser's default system locale
        return date.toLocaleString(undefined, {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
        });
    }

    


    let userId = comment.CreatedBy;
    let user = AppContext.getUserById(userId);
    let commentText = comment.Text;
    let date = formatDate(comment.CreatedDate);
    let commentId = comment.Id;

    return (
        <>
            <div style={{ display: "flex", flexDirection: "row" }}>
                <div><User value={userId} /></div>
                <div style={{ display: "flex", flexDirection: "column", flex: 1, marginLeft: "10px" }}>
                    <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
                        <div style={{ flex: 1, fontWeight: "bold" }}>{user?.Name}</div>
                        <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                            <div style={{ color: "#a8a8a8", marginRight: "5px" }}>{date}</div>

                            {userId == AppContext.currentUserId ? (
                                <div style={{ display: "flex", flexDirection: "row" }}>
                                    {isShowingOptions ? (
                                        <>
                                            {!isShowingDeleteCommentButton && (
                                                <div>
                                                    <button onClick={() => setIsShowingDeleteCommentButton(true)} className="action-button options-button" title="Delete comment"><i className="fas fa-trash-alt"></i></button>
                                                </div>
                                            )}

                                            {isShowingDeleteCommentButton && (
                                                isDeletingComment ? (
                                                    <div><LoadingSpinnerImage /></div>
                                                ) : (
                                                    <div>
                                                        <button onClick={() => { setIsDeletingComment(true); deleteCommentFunc(commentId); }} className="action-button delete-button" title="Confirm deletion"><i className="fas fa-trash-alt"></i> Yes, delete</button>
                                                    </div>
                                                )
                                            )}

                                            <div>
                                                <button onClick={() => showOptions(false)} className="action-button options-button" title="Cancel">Cancel</button>
                                            </div>
                                        </>
                                    ) : (
                                        <div>
                                            <button onClick={() => showOptions(true)} className="action-button options-button" title="Show options"><i className="fas fa-ellipsis-v"></i></button>
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <div style={{ width: "40px" }}></div>
                            )}
                        </div>
                    </div>
                    <div>{commentText}</div>
                </div>
            </div>

            <div style={{ marginTop: "20px", borderTop: "1px solid #f3f3f3", marginBottom: "20px" }}></div>
        </>
    );
};




/*
  This draws the tasks table
*/

const TaskManagerTable = () => {
    const AppContext = useContext(TaskManagerAppContext);
    let tasks = AppContext.tasks;
    let header = [];

    header.push({ name: "", field: "CompletionStatus", width: "25px" });
    header.push({ name: "", field: "", width: "20px" });
    header.push({ name: "Task name", field: "Name", width: "40%" });
    header.push({ name: "Assigned To", field: "AssignedTo", width: "8%" });
    header.push({ name: "Due Date", field: "DueDate", width: "8%" });
    header.push({ name: "Priority", field: "Priority", width: "10%" });
    header.push({ name: "Board", field: "BoardStep", width: "10%" });
    header.push({ name: "Country", field: "Country", width: "8%" });
    header.push({ name: "Start Date", field: "StartDate", width: "8%" });
    header.push({ name: "Estimated Time", field: "EstimatedTime", width: "8%" });

    let headerHeight = 320;
    let maxHeight = (windowHeight - headerHeight) + "px";

    // Try this
    maxHeight = "100vh";



    // SCROLLING BEHAVIOUR

    
    const targetRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                setIsVisible(entry.isIntersecting);
            },
            { threshold: 0 } // Adjust the threshold as needed
        );

        if (targetRef.current) {
            observer.observe(targetRef.current);
        }

        return () => {
            if (targetRef.current) {
                observer.unobserve(targetRef.current);
            }
        };
    }, [AppContext.isLoadingTasks]);


    useEffect(() => {

        //console.log("Current state: ", isVisible, AppContext.hasMoreData, !AppContext.isLoadingTasks, !AppContext.isLoadingSubTasks);

        if (isVisible && AppContext.hasMoreData && !AppContext.isLoadingTasks && !AppContext.isLoadingSubTasks) {
            //console.log("loads more tasks from visible ref element");
            AppContext.loadTasks({ nextPage: true });
        }
    }, [isVisible]);














    return (
        <div className="datatable-container thin-scrollbar" style={{ borderBottom: "1px solid #fdfdfd", maxHeight: maxHeight, overflowX: "auto", overflowY: "auto hidden"
}}>

            {/* Header row */}

            <div
                className="datatable-header"
                style={AppContext.hasLimitedWidth ? { width: "100%" } : { minWidth: "1000px" }}
            >
                {header.map((item, index) => (
                    <div key={index}
                        style={{ width: `${item.width}`, cursor: "pointer", }}
                        onClick={() => {
                            if (!AppContext.isLoadingTasks && !AppContext.isLoadingSubTasks) {
                                AppContext.changeTaskListOrderField(item.field)
                            }
                        }}
                    >
                        <span
                            className="table-column-filter"
                        >
                            {item.name}
                            {AppContext.taskListSortByField == item.field ? (
                                AppContext.taskListSortByType == "ASCENDING" ? (
                                    <i
                                        style={{ marginLeft: "5px" }}
                                        className="fas fa-long-arrow-alt-up"
                                    ></i>
                                ) : (
                                    <i
                                        style={{ marginLeft: "5px" }}
                                        className="fas fa-long-arrow-alt-down"
                                    ></i>
                                )
                            ) : null}
                        </span>
                    </div>
                ))}
            </div>

            {/* Result rows */}

            <div
                className="datatable-content thin-scrollbar"
                style={{
                    overflowY: "auto",
                    overflowX: "hidden",
                    ...(AppContext.hasLimitedWidth ? { width: "auto" } : { minWidth: "1000px" })
                }}
            >
                <div>
                    {tasks.map((item, index) => {

                        if (item.ParentTaskId)
                            return;

                        let col = 0;

                        return (
                            <React.Fragment key={index}>
                                <div className="datatable-row" key={index}>
                                    <div style={{ width: header[col++].width }}>
                                        <CompletionStatus value={AppContext.getCompletenessById(item.CompletionStatus)?.name} onlyIcon="true" />
                                    </div>
                                    <div style={{ width: header[col++].width, cursor: item.SubtaskCount > 0 ? "pointer" : null }} onClick={() => {
                                        if (!AppContext.isLoadingTasks && !AppContext.isLoadingSubTasks) {
                                            item.SubtaskCount > 0 ? AppContext.loadSubTasks({ parentTaskId: item.Id }) : null
                                        }
                                    }}>

                                        {item.SubtaskCount > 0 ? <>

                                            {AppContext.loadedSubTasksForTaskId.find((loadedItem) => loadedItem == item.Id) ? <>
                                                <i style={{ fontSize: "14pt" }} className="fas fa-angle-down"></i>
                                            </> : <>
                                                <i style={{ fontSize: "14pt" }} className="fas fa-angle-right"></i>
                                            </>}

                                        </> : null}

                                    </div>
                                    <div style={{ width: header[col++].width, cursor: "pointer" }} onClick={(e) => AppContext.loadTaskDetails(item.Id, e)}>
                                        <div style={{ display: "flex", flexDirection: "row", minWidth: 0 }}>
                                            <div title={item.Name} className="ellipsis">
                                                {item.Name}
                                            </div>
                                            {item.SubtaskCount != 0 ?
                                                <div title="Subtasks" style={{ flex: 1, display: "flex", flexDirection: "row", marginLeft: "15px" }}>
                                                    <div style={{marginRight: "5px"}}><img style={{ width: "10px" }} src="/assets/images/subtask_icon.png" /></div><div title={`${item.SubtaskCount} Subtasks`}>{item.SubtaskCount}</div>
                                                </div>
                                                : null
                                            }
                                        </div>
                                    </div>
                                    <div style={{ width: header[col++].width }}>
                                        <User value={item.AssignedTo} />
                                    </div>
                                    <div style={{ width: header[col++].width }}><DueDate date={item.DueDate} showYear="true" /></div>
                                    <div style={{ width: header[col++].width }}>
                                        <Priority value={item.Priority} />
                                    </div>
                                    <div style={{ width: header[col++].width }}>
                                        <BoardStep value={item.BoardStep} />
                                    </div>
                                    <div style={{ width: header[col++].width }}>
                                        {item.Relationship_Task_Entity
                                            ?.filter(entity => entity.EntityType === 'countryregistration-country')
                                            ?.map(entity => entity.EntityName)
                                            ?.join(', ') || ''}
                                    </div>
                                    <div style={{ width: header[col++].width }}>{AppContext.readableDate(item.StartDate)}</div>
                                    <div style={{ width: header[col++].width }}>{item.EstimatedTime}h</div>
                                </div>

                                {AppContext.isLoadingSubTasks == item.Id ? <>

                                    <div className="datatable-row">
                                        <div style={{ textAlign: "center", display: "flex", justifyContent: "center", width: "67px" }}>
                                            <LoadingSpinnerImage />
                                        </div>
                                    </div>

                                </> : <>

                                    {AppContext.loadedSubTasksForTaskId.find((loadedItem) => loadedItem == item.Id) ? <>


                                        {tasks.filter((subitem) => subitem.ParentTaskId == item.Id).map((subitem, subindex) => {

                                            let subtaskCol = 0;

                                            return (
                                                <div className="datatable-row" key={`subtask_${subindex}`}>
                                                    <div style={{ width: header[subtaskCol++].width, borderBottom: "0px" }}>

                                                    </div>
                                                    <div style={{ width: header[subtaskCol++].width, padding: "0px", borderBottom: "0px" }} >
                                                        <span style={{ display: "inline-block", width: "100%", height: "40px" }}>

                                                        </span>
                                                    </div>
                                                    <div style={{ width: header[subtaskCol++].width, cursor: "pointer" }} onClick={(e) => AppContext.loadTaskDetails(subitem.Id, e)}>
                                                        <div title={subitem.Name} className="ellipsis">
                                                            <span style={{ paddingRight: "10px" }}>
                                                                <CompletionStatus value={AppContext.getCompletenessById(subitem.CompletionStatus)?.name} onlyIcon="true" />
                                                            </span>{subitem.Name}
                                                        </div>
                                                    </div>
                                                    <div style={{ width: header[subtaskCol++].width }}>
                                                        <User value={subitem.AssignedTo} />
                                                    </div>
                                                    <div style={{ width: header[subtaskCol++].width }}><DueDate date={subitem.DueDate} showYear="true" /></div>
                                                    <div style={{ width: header[subtaskCol++].width }}>
                                                        <Priority value={subitem.Priority} />
                                                    </div>
                                                    <div style={{ width: header[subtaskCol++].width }}>
                                                        <BoardStep value={subitem.BoardStep} />
                                                    </div>
                                                    <div style={{ width: header[subtaskCol++].width }}>{AppContext.readableDate(subitem.StartDate)}</div>
                                                    <div style={{ width: header[subtaskCol++].width }}>{subitem.EstimatedTime}h</div>
                                                </div>
                                            );

                                        })}


                                    </> : null}


                                </>}

                                    
                            </React.Fragment>
                        )
                        }
                        )}
                </div>




                {/* Loading and no-more-results row */}

                {AppContext.isLoadingTasks ? 
                    <div style={{ textAlign: "center" }}>
                        <LoadingSpinnerImage />
                    </div>
                 :
                    <>
                        {/* If this div is visible it should try to load more tasks. Either inner div content or minHeight is mandatory for the intersector to work */}
                        <div ref={targetRef} style={{minHeight: "5px"}}></div>  
                    </>
                }



                {!AppContext.hasMoreData ?
                    <>
                        {AppContext.showRefreshLastLoadData ? 
                            <div className="no-more-results" >
                                <span onClick={() => AppContext.loadTasks({ nextPage: true })} style={{ padding: "3px 7px", border: "1px solid #eee", borderRadius: "10px", backgroundColor: "#eff8ff", cursor: "pointer" }}>Reload</span>
                            </div>
                        :
                            <div className="no-more-results">No more tasks</div>
                        }
                    </>
                : null }


                  

                

            </div>
        </div>
    );
};

const DueDate = ({ date, showYear = false }) => {
    const AppContext = useContext(TaskManagerAppContext);

    let className = "due-date";

    const currentDate = new Date();
    const checkedDate = new Date(date);

    // Normalize both dates to midnight UTC
    currentDate.setUTCHours(0, 0, 0, 0);
    checkedDate.setUTCHours(0, 0, 0, 0);

    const now = currentDate.getTime();
    const task = checkedDate.getTime();

    if (task < now) {
        className = "due-date-late";
    } else if (task === now) {
        className = "due-date-today";
    }

    return (
        <span className={className}>
            {AppContext.readableDate(date, showYear)}
        </span>
    );
};

const ScrollableTable = ({ id, children }) => {
    const handleScroll = () => {
        console.log("Scrolled");
    };

    useEffect(() => {
        console.log(document.getElementById(id));

        //document.getElementById("id").addEventListener('scroll', handleScroll);

        return () => {
            //document.getElementById(id).removeEventListener('scroll', handleScroll);
        };
    });

    return <>{children}</>;
};

const BoardStep = ({ value }) => {
    const AppContext = useContext(TaskManagerAppContext);

    let boardStepInfo = AppContext.getBoardStepById(value);

    return (
        <>
            {boardStepInfo ? (
                <div>
                    <i
                        style={{
                            textAlign: "center",
                            color: boardStepInfo?.BoardStepColor,
                            fontSize: "6pt"
                        }}
                        className="fas fa-circle"
                    ></i>{" "}
                    {boardStepInfo?.BoardStepName}
                </div>
            ) : (
                <span style={{ borderRadius: "5px", padding: "4px", backgroundColor: "#f0f0f0" }}>
                    None
                </span>
            )}
        </>
    );
};

const User = ({ value, size }) => {
    const AppContext = useContext(TaskManagerAppContext);

    let user = AppContext.getUserById(value);

    return (
        <>
            {user ? (
                <div
                    className={
                        "user-initials-circle " +
                        (size == "small" ? "user-initials-circle-small" : "")
                    }
                    style={{ backgroundColor: user?.IsItMe ? "#0176b9" : "#e7e7e7", color: user?.IsItMe ? "white" : "black" }}
                    title={user?.Name}
                >
                    {user?.Initials}
                </div>
            ) : null}
        </>
    );
};

const Priority = ({ value, size }) => {
    const AppContext = useContext(TaskManagerAppContext);
    let bgcolor = "";
    let color = "white";

    switch (String(value)) {
        case "1":
            bgcolor = "#d1153a";
            break;
        case "2":
            bgcolor = "#f7b204";
            break;
        case "3":
            bgcolor = "#48ca94";
            break;
        case "4":
            bgcolor = "#f0f0f0";
            color = "#333";
            break;
        default:
            break;
    }

    let padding = "5px";
    let width = "100px";

    if (size == "small") {
        padding = "2px";
        width = "70px";
    }

    return (
        <>
            <div
                style={{
                    padding: padding,
                    borderRadius: "5px",
                    textAlign: "center",
                    color: color,
                    width: width,
                    backgroundColor: bgcolor
                }}
            >
                {AppContext.getPriorityById(value)?.name}
            </div>
        </>
    );
};




const BoardConfiguration_OLD = () => {
    const AppContext = useContext(TaskManagerAppContext);

    let boardSteps = AppContext.boards[0] ? AppContext.boards[0].Steps : [];

    let sortedBoardSteps = boardSteps.sort(
        (a, b) => a.BoardStepOrder - b.BoardStepOrder
    );



    return (
        <>
            <h2>Board Configuration</h2>
            {sortedBoardSteps.map((item, index) => (
                <div
                    key={index}
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        marginBottom: "3px",
                        backgroundColor: "#fafafa"
                    }}
                >
                    <div
                        style={{
                            width: "10px",
                            paddingLeft: "5px",
                            borderRadius: "2px 0px 0px 2px",
                            borderLeft: "7px solid " + item.BoardStepColor
                        }}
                    ></div>
                    <div
                        style={{
                            padding: "4px 0px",
                            width: "200px",
                            display: "flex",
                            alignItems: "center"
                        }}
                    >
                        {AppContext.isEditingBoardNameWithId !== item.BoardStepId ? (
                            <>
                                <span
                                    className="editable-field-span ellipsis"
                                    onClick={() =>
                                        AppContext.setIsEditingBoardNameWithId(item.BoardStepId)
                                    }
                                >
                                    {item.BoardStepName}
                                </span>
                            </>
                        ) : (
                            <>
                                <span style={{ padding: "3px" }}>
                                    <input
                                        className=""
                                        autoFocus
                                        onBlur={() => AppContext.setIsEditingBoardNameWithId(null)}
                                        onChange={(e) =>
                                            AppContext.changeBoardStepName(
                                                item.BoardStepId,
                                                e.target.value
                                            )
                                        }
                                        value={item.BoardStepName}
                                    />
                                </span>
                            </>
                        )}
                    </div>

                    <div style={{ display: "flex", alignItems: "center", width: "25px" }}>
                        {index > 0 ? (
                            <span
                                onClick={() =>
                                    AppContext.reorderBoardSteps(item.BoardStepId, "up")
                                }
                            >
                                <i className="fas fa-arrow-up"></i>
                            </span>
                        ) : (
                            <i style={{ color: "#c0c0c0" }} className="fas fa-arrow-up"></i>
                        )}
                    </div>

                    <div style={{ display: "flex", alignItems: "center", width: "25px" }}>
                        {index < sortedBoardSteps.length - 1 ? (
                            <span
                                onClick={() =>
                                    AppContext.reorderBoardSteps(item.BoardStepId, "down")
                                }
                            >
                                <i className="fas fa-arrow-down"></i>
                            </span>
                        ) : (
                            <i style={{ color: "#c0c0c0" }} className="fas fa-arrow-down"></i>
                        )}
                    </div>

                    <div
                        style={{
                            paddingTop: "5px",
                            display: "flex",
                            alignItems: "center",
                            width: "60px"
                        }}
                    >
                        <div>
                            <div
                                style={{
                                    padding: "5px",
                                    background: "#fff",
                                    borderRadius: "1px",
                                    boxShadow: "0 0 0 1px rgba(0,0,0,.1)",
                                    display: "inline-block",
                                    cursor: "pointer"
                                }}
                                onClick={() => AppContext.handleColorPickerOpen(index)}
                            >
                                <div
                                    style={{
                                        width: "36px",
                                        height: "14px",
                                        borderRadius: "2px",
                                        background: item.BoardStepColor
                                    }}
                                />
                            </div>

                            {AppContext.displayColorPicker == index ? (
                                <div style={{ position: "absolute", zIndex: "2" }}>
                                    <div
                                        style={{
                                            position: "fixed",
                                            top: "0px",
                                            right: "0px",
                                            bottom: "0px",
                                            left: "0px"
                                        }}
                                        onClick={AppContext.handleColorPickerClose}
                                    />
                                    <TwitterPicker
                                        color={item.BoardStepColor}
                                        onChange={(color) =>
                                            AppContext.handleColorPickerChange(
                                                color,
                                                item.BoardStepId
                                            )
                                        }
                                    />
                                </div>
                            ) : null}
                        </div>
                    </div>

                    <div style={{ display: "flex", alignItems: "center", width: "25px" }}>
                        <span onClick={() => AppContext.removeBoardStep(item.BoardStepId)}>
                            <i className="far fa-trash-alt"></i>
                        </span>
                    </div>
                </div>
            ))}

            <div
                style={{
                    display: "flex",
                    padding: "3px",
                    border: "1px dashed #c0c0c0"
                }}
            >
                <div style={{ width: "15px" }}></div>
                <input
                    type="text"
                    placeholder="Column name..."
                    value={AppContext.newBoardStepName}
                    onChange={(e) => AppContext.setNewBoardStepName(e.target.value)}
                />
                <button
                    style={{ marginLeft: "10px" }}
                    onClick={AppContext.addBoardStep}
                    className="action-button save-button"
                >
                    Add
                </button>
            </div>

            <div style={{ marginTop: "20px", textAlign: "center" }}>
                {AppContext.isSavingBoard == false ? (
                    <>
                        <button
                            className="action-button save-button"
                            onClick={AppContext.saveBoardConfiguration}
                        >
                            Save Board Configuration
                        </button>
                    </>
                ) : (
                    <>
                        <LoadingSpinnerImage />
                    </>
                )}
            </div>
        </>
    );
};



/* BOARD CONFIGURATION SCREEN */
/* BOARD CONFIGURATION SCREEN */
/* BOARD CONFIGURATION SCREEN */


const BoardConfiguration = () => {

    const AppContext = useContext(TaskManagerAppContext);
    const [localBoardSteps, setLocalBoardSteps] = useState([]);
    const [localBoardStepsSorted, setLocalBoardStepsSorted] = useState([]);
    const [isEditingBoardNameWithId, setIsEditingBoardNameWithId] = useState(null);
    const [displayColorPicker, setDisplayColorPicker] = useState(null);
    const [newBoardStepName, setNewBoardStepName] = useState("");

    useEffect(() => {
        let boardSteps = AppContext.boards[0] ? JSON.parse(JSON.stringify(AppContext.boards[0].Steps)) : [];

        setLocalBoardSteps(boardSteps);

    }, []);

    useEffect(() => {

        let localBoardStepsSorted = localBoardSteps.sort(
            (a, b) => a.BoardStepOrder - b.BoardStepOrder
        );

        setLocalBoardStepsSorted(localBoardStepsSorted);

    }, [localBoardSteps]);


    const changeBoardStepName = (boardStepId, name) => {
        let updatedBoardSteps = localBoardSteps.map((item) => {
            if (item.BoardStepId == boardStepId) item.BoardStepName = name;
            return item;
        });

        setLocalBoardSteps(updatedBoardSteps);
    };
    
    const reorderBoardSteps = (boardStepId, direction) => {
        let currentOrder = localBoardSteps.find(
            (item) => item.BoardStepId == boardStepId
        )?.BoardStepOrder;

        if (currentOrder == 1 && direction == "up") return;
        if (currentOrder == localBoardSteps.length && direction == "down") return;

        let nextOrder = direction == "up" ? currentOrder - 1 : currentOrder + 1;

        let steps = localBoardSteps.map((step) => {
            if (step.BoardStepOrder == currentOrder) {
                step.BoardStepOrder = nextOrder;
                return step;
            }

            if (step.BoardStepOrder == nextOrder) {
                step.BoardStepOrder = currentOrder;
                return step;
            }

            return step;
        });

        setLocalBoardSteps(steps);

    };

    const handleColorChangeComplete = (color) => {
        console.log("Color:" + color);
    };

    const handleColorPickerOpen = (index) => {
        setDisplayColorPicker(index);
    };

    const handleColorPickerClose = () => {
        setDisplayColorPicker(null);
    };

    const handleColorPickerChange = (color, boardStepId) => {
        let updatedBoardSteps = localBoardSteps.map((item) => {
            if (item.BoardStepId == boardStepId) {
                item.BoardStepColor = color.hex;
                return item;
            }
            return item;
        });

        setLocalBoardSteps(updatedBoardSteps);
    };

    const removeBoardStep = (boardStepId) => {
        let orderOfDeletedItem = null;

        // Remove selected board step
        let updatedBoardSteps = localBoardSteps.filter((item) => {
            if (item.BoardStepId == boardStepId) {
                orderOfDeletedItem = item.BoardStepOrder;
                return false;
            }
            return true;
        });

        // Update the order of the following steps
        updatedBoardSteps = updatedBoardSteps.map((item) => {
            if (item.BoardStepOrder > orderOfDeletedItem) {
                item.BoardStepOrder -= 1;
                return item;
            }
            return item;
        });

        setLocalBoardSteps(updatedBoardSteps);
    };



    const addBoardStep = () => {
        // get the new temporary id
        let newTempId = -1;

        for (let step in localBoardSteps)
            if (localBoardSteps[step].BoardStepId <= newTempId)
                newTempId = localBoardSteps[step].BoardStepId - 1;

        let newStep = {
            BoardId: AppContext.boards[0].Id,
            BoardStepId: newTempId,
            BoardStepName: newBoardStepName,
            BoardStepColor: "#FFF",
            BoardStepOrder: localBoardSteps.length + 1
        };

        let result = [...localBoardSteps, newStep];

        setLocalBoardSteps(result);
    };


    return (
        <>
            <div style={{ textAlign: "center" }}>
                <h2>Board Configuration</h2>

                <div style={{marginBottom: "15px", }} dangerouslySetInnerHTML={{ __html: window.umbracoMessage_BoardConfiguration }} />
            </div>

            {localBoardStepsSorted.map((item, index) => (
                <div
                    key={index}
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        marginBottom: "3px",
                        backgroundColor: "#fafafa"
                    }}
                >
                    {/* COLOR */}

                    <div
                        style={{
                            width: "10px",
                            paddingLeft: "5px",
                            borderRadius: "2px 0px 0px 2px",
                            borderLeft: "7px solid " + item.BoardStepColor
                        }}
                    ></div>

                    {/* NAME */}

                    <div
                        style={{
                            padding: "4px 0px",
                            width: "200px",
                            display: "flex",
                            alignItems: "center"
                        }}
                    >
                        {isEditingBoardNameWithId !== item.BoardStepId ? (
                            <>
                                <span
                                    className="editable-field-span ellipsis"
                                    onClick={() =>
                                        setIsEditingBoardNameWithId(item.BoardStepId)
                                    }
                                >
                                    {item.BoardStepName}
                                </span>
                            </>
                        ) : (
                            <>
                                <span style={{ padding: "3px" }}>
                                    <input
                                        className=""
                                        autoFocus
                                        onBlur={() => setIsEditingBoardNameWithId(null)}
                                        onChange={(e) =>
                                            changeBoardStepName(
                                                item.BoardStepId,
                                                e.target.value
                                            )
                                        }
                                        value={item.BoardStepName}
                                    />
                                </span>
                            </>
                        )}
                    </div>

                    {/* ORDER UP */}

                    <div style={{ display: "flex", alignItems: "center", width: "25px" }}>
                        {index > 0 ? (
                            <span
                                onClick={() =>
                                    reorderBoardSteps(item.BoardStepId, "up")
                                }
                            >
                                <i className="fas fa-arrow-up"></i>
                            </span>
                        ) : (
                            <i style={{ color: "#c0c0c0" }} className="fas fa-arrow-up"></i>
                        )}
                    </div>

                    {/* ORDER DOWN */}

                    <div style={{ display: "flex", alignItems: "center", width: "25px" }}>
                        {index < localBoardSteps.length - 1 ? (
                            <span
                                onClick={() =>
                                    reorderBoardSteps(item.BoardStepId, "down")
                                }
                            >
                                <i className="fas fa-arrow-down"></i>
                            </span>
                        ) : (
                            <i style={{ color: "#c0c0c0" }} className="fas fa-arrow-down"></i>
                        )}
                    </div>

                    {/* COLOR PICKER */}

                    <div
                        style={{
                            paddingTop: "5px",
                            display: "flex",
                            alignItems: "center",
                            width: "60px"
                        }}
                    >
                        <div>
                            <div
                                style={{
                                    padding: "5px",
                                    background: "#fff",
                                    borderRadius: "1px",
                                    boxShadow: "0 0 0 1px rgba(0,0,0,.1)",
                                    display: "inline-block",
                                    cursor: "pointer"
                                }}
                                onClick={() => handleColorPickerOpen(index)}
                            >
                                <div
                                    style={{
                                        width: "36px",
                                        height: "14px",
                                        borderRadius: "2px",
                                        background: item.BoardStepColor
                                    }}
                                />
                            </div>

                            {displayColorPicker == index ? (
                                <div style={{ position: "absolute", zIndex: "2" }}>
                                    <div
                                        style={{
                                            position: "fixed",
                                            top: "0px",
                                            right: "0px",
                                            bottom: "0px",
                                            left: "0px"
                                        }}
                                        onClick={handleColorPickerClose}
                                    />
                                    <TwitterPicker
                                        color={item.BoardStepColor}
                                        onChange={(color) =>
                                            handleColorPickerChange(
                                                color,
                                                item.BoardStepId
                                            )
                                        }
                                    />
                                </div>
                            ) : null}
                        </div>
                    </div>

                    {/* REMOVE STEP */}

                    <div style={{ display: "flex", alignItems: "center", width: "25px" }}>
                        <span onClick={() => removeBoardStep(item.BoardStepId)}>
                            <i className="far fa-trash-alt"></i>
                        </span>
                    </div>
                </div>
            ))}

            {/* ADD STEP */}

            <div
                style={{
                    display: "flex",
                    padding: "3px",
                    border: "1px dashed #c0c0c0"
                }}
            >
                <div style={{ width: "15px" }}></div>
                <input
                    type="text"
                    placeholder="Column name..."
                    value={newBoardStepName}
                    onChange={(e) => setNewBoardStepName(e.target.value)}
                />
                <button
                    style={{ marginLeft: "10px" }}
                    onClick={addBoardStep}
                    className="action-button save-button"
                >
                    Add
                </button>
            </div>

            {/* SAVE BOARD */}

            <div style={{ marginTop: "20px", textAlign: "center" }}>
                {AppContext.isSavingBoard == false ? (
                    <>
                        <button
                            className="action-button save-button"
                            onClick={() => AppContext.saveBoardConfiguration(localBoardStepsSorted)}
                        >
                            Save Board Configuration
                        </button>
                    </>
                ) : (
                    <>
                        <LoadingSpinnerImage />
                    </>
                )}
            </div>
        </>
    );
};












const BoardView = () => {
    const AppContext = useContext(TaskManagerAppContext);

    let boardSteps = AppContext.boards[0] ? AppContext.boards[0].Steps : [];

    let sortedBoardSteps = boardSteps.sort(
        (a, b) => a.BoardStepOrder - b.BoardStepOrder
    );

    return (
        <>
            <div className="thin-scrollbar board-view">

                {/* NO STEPS? SHOW INITIAL WIZARD */}

                {sortedBoardSteps.length == 0 && <>

                    <div style={{
                        width: "100%",
                        marginTop: "50px",
                    }}>
                        <span style={{marginBottom: "30px"}}>This is a fresh new board! Add your first step to start using it.</span>
                        <br/><br/>
                        <span style={{ padding: "6px 15px", backgroundColor: "#cff4ff", borderRadius: "10px", cursor: "pointer" }} onClick={() => AppContext.setTaskView("board-configuration")}>Add a step</span>
                    </div>

                </>}

                {/* HAS STEPS? SHOW BOARD */}

                {sortedBoardSteps.map((item, index) => (

                    <div key={index} className="board-view-step" style={{ /*maxHeight: `calc(100vh - ${AppContext.windowSpacing})`,*/ }} >

                        <div style={{ backgroundColor: item.BoardStepColor, height: "5px" }}></div>
                        <div style={{ textAlign: "center" }}>
                            <h3>{item.BoardStepName}</h3>
                        </div>
                        <div className="thin-scrollbar" style={{ height: "100%", overflowY: "auto", }} >
                            {AppContext.tasks
                                .filter((taskItem) => taskItem.BoardStep == item.BoardStepId)
                                .map((task, index) => (
                                    <BoardTask key={index} task={task} />
                                ))}
                        </div>

                    </div>
                ))}
            </div>
        </>
    );
};


const BoardTask = ({ task }) => {
    const AppContext = useContext(TaskManagerAppContext);

    return (
        <>
            <div
                onClick={(e) => AppContext.loadTaskDetails(task.Id, e)}
                style={{
                    cursor: "pointer",
                    margin: "2px",
                    padding: "5px",
                    backgroundColor: "white",
                    border: "1px solid #c0c0c0",
                    borderRadius: "5px",
                    marginBottom: "10px"
                }}
            >
                <div style={{ textAlign: "left", fontWeight: "bold" }}>{task.Name}</div>
                <br/>
                <div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                    <div style={{ marginRight: "5px" }}>Priority: </div>
                    <div><Priority value={task.Priority} size="small" /></div>
                </div>
                <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                    <div style={{ marginRight: "5px" }}>Due Date: </div>
                    <div><DueDate date={task.DueDate} showYear="true" /></div>
                </div>
                <br />
                <div style={{display: "flex", flexDirection: "row"}}>
                    <div>
                        <User value={task.AssignedTo} />
                    </div>
                    {task.CompletionStatus == 1 && 
                        <div style={{ marginLeft: "5px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <CompletionStatus value={AppContext.getCompletenessById(task.CompletionStatus)?.name} onlyIcon="true" />
                        </div>
                    }
                </div>
                 
            </div>
        </>
    );
};




export default TaskManagerApp;
